import React, { useState, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import axios from "../../../../axios-order";
import { ToastContainer } from 'react-toastify';
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useHistory, useParams, useLocation } from 'react-router-dom';
import {
    MenuItem, Select, Dialog, DialogTitle,
    DialogContent, DialogActions,
} from "@mui/material";
import { ValidatorForm } from "react-material-ui-form-validator";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import WarningIcon from '@mui/icons-material/Warning';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import moment from 'moment';
import Tooltip from "@mui/material/Tooltip";
import excelIconImage from '../../../../asserts/images/excelicon.svg';
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Inputfield from "../../../../components/ui/inputField";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { generateUUID } from '../../../../utils/sseUtils';
import { SSE_BASE_URL } from '../../../../axios-order';

import {
    Modal,
    Box,
    Typography,
    Button,
    CircularProgress,
    Checkbox,
    ListItemText,
    TablePagination,
    Snackbar, Alert
} from "@mui/material";
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid-pro';

// DashboardCard Component (unchanged)

// const LogTable = ({ recordForLogTable, loaderForTable, getApiLogReport, handleViewData, onClickExport }) => {
//     return (
// <BoxWrapper
//     boxTitle="IMS Reconciliation"
//     addButtonLabel="Refresh"
//     enableAddButton={true}
//     // addButtonLabel="Refresh"
//     addButtonHandlerFn={getApiLogReport}
// >
//     <div style={{
//         maxHeight: "400px", // Set max height for vertical scrolling
//         overflowY: "auto", // Enable vertical scrolling
//         overflowX: "auto", // Enable horizontal scrolling
//         width: "100%", // Ensure the div takes full width
//     }} >
//         <table className="custome-table">
//             <thead>
//                 <tr>
//                     <th>Recon Datetime</th>
//                     <th>Created Date</th>
//                     <th>Status</th>
//                     <th>Action</th>

//                 </tr>
//             </thead>
//             <tbody>
//                 {recordForLogTable?.map((v, index) => {
//                     // Determine if the icon should be disabled
//                     const isDisabled =
//                         v.status?.toLowerCase() === "initiated" ||
//                         v.status?.toLowerCase() === "in progress" ||
//                         v.status?.toLowerCase() === "failed";

//                     return (
//                         <tr key={v.id}>
//                             <td>{v.recon_datetime}</td>
//                             <td>{v.created_date}</td>
//                             <td>{v.status}</td>
//                             <td>
//                                 <VisibilityOutlinedIcon
//                                     sx={{
//                                         color: isDisabled ? "gray" : "#64adf7", // Gray when disabled, blue when enabled
//                                         cursor: isDisabled ? "not-allowed" : "pointer", // Change cursor style
//                                         opacity: isDisabled ? 0.5 : 1, // Reduce opacity for disabled state
//                                     }}
//                                     onClick={
//                                         isDisabled
//                                             ? () => { } // No action if disabled
//                                             : () => handleViewData(v.ims_recon_id, v.tax_period) // Enable click action if status is "Passed"
//                                     }
//                                 />

//                                 {
//                                     (v.status === "Pass") ? (
//                                         v.is_valid !== "N" ?
//                                             (
//                                                 (!v.excel_loading ?
//                                                     <img
//                                                         onClick={isDisabled ? () => { } : () => onClickExport(v.ims_recon_id)}
//                                                         style={{
//                                                             marginLeft: '5px',
//                                                             height: '23px',
//                                                             width: '25px',
//                                                             cursor: isDisabled ? 'not-allowed' : 'pointer',
//                                                             opacity: isDisabled ? 0.5 : 1,
//                                                             filter: isDisabled ? 'grayscale(100%)' : 'none'
//                                                         }}
//                                                         src={excelIconImage}
//                                                     />
//                                                     : <>
//                                                         <CircularProgress
//                                                             size={20}
//                                                             style={{ color: "green", marginLeft: '5px', marginTop: '2px' }}
//                                                         />
//                                                     </>)
//                                             )
//                                             :
//                                             (
//                                                 <Tooltip title="Recon is Invalid">
//                                                     <img
//                                                         style={{
//                                                             marginLeft: '5px',
//                                                             height: '23px',
//                                                             width: '25px',
//                                                             opacity: isDisabled ? 0.5 : 1,
//                                                             filter: isDisabled ? 'grayscale(100%)' : 'none',
//                                                             cursor: isDisabled ? 'not-allowed' : 'default'
//                                                         }}
//                                                         src={excelIconImage}
//                                                     />
//                                                 </Tooltip>
//                                             )
//                                     ) : (
//                                         <img
//                                             style={{
//                                                 marginLeft: '5px',
//                                                 height: '23px',
//                                                 width: '25px',
//                                                 cursor: isDisabled ? 'not-allowed' : 'pointer',
//                                                 opacity: isDisabled ? 0.5 : 1,
//                                                 filter: isDisabled ? 'grayscale(100%)' : 'none'
//                                             }}
//                                             src={excelIconImage}
//                                             onClick={isDisabled ? () => { } : () => onClickExport(v.ims_recon_id)}
//                                         />
//                                     )
//                                 }
//                             </td>
//                         </tr>
//                     );
//                 })}
//                 {loaderForTable ? (
//                     <tr>
//                         <td
//                             colSpan={4}
//                             style={{
//                                 color: "black",
//                                 textAlign: "center",
//                                 fontWeight: "bold",
//                             }}
//                         >
//                             Loading…Please wait
//                         </td>
//                     </tr>
//                 ) : recordForLogTable?.length === 0 ? (
//                     <tr>
//                         <td colSpan={4} style={{ color: "red", textAlign: "center" }}>
//                             No Data Found!
//                         </td>
//                     </tr>
//                 ) : null}
//             </tbody>
//             {/* <tbody>
//                 {recordForLogTable?.map((v, index) => {
//                     // Determine if the icon should be disabled
//                     const isDisabled =
//                         v.status?.toLowerCase() === "initiated" ||
//                         v.status?.toLowerCase() === "in progress" ||
//                         v.status?.toLowerCase() === "failed";

//                     return (
//                         <tr key={v.id}>
//                             <td>{v.recon_datetime}</td>
//                             <td>{v.created_date}</td>
//                             <td>{v.status}</td>
//                             <td>
//                                 <VisibilityOutlinedIcon
//                                     sx={{
//                                         color: isDisabled ? "gray" : "#64adf7", // Gray when disabled, blue when enabled
//                                         cursor: isDisabled ? "not-allowed" : "pointer", // Change cursor style
//                                         opacity: isDisabled ? 0.5 : 1, // Reduce opacity for disabled state
//                                     }}
//                                     onClick={
//                                         isDisabled
//                                             ? () => { } // No action if disabled
//                                             : () => handleViewData(v.ims_recon_id, v.tax_period) // Enable click action if status is "Passed"
//                                     }
//                                 />

//                                 {
//                                     (v.status === "Pass") ? (
//                                         v.is_valid !== "N" ?

//                                             (
//                                                 (!v.excel_loading ? <img onClick={() => onClickExport(v.ims_recon_id)} style={{ marginLeft: '5px', height: '23px', width: '25px', cursor: 'pointer' }} src={excelIconImage} />
//                                                     : <>
//                                                         <CircularProgress
//                                                             size={20}
//                                                             style={{ color: "green", marginLeft: '5px', marginTop: '2px' }}
//                                                         />
//                                                     </>)
//                                             )

//                                             :

//                                             (
//                                                 <Tooltip title="Recon is Invalid">
//                                                     <img style={{ marginLeft: '5px', height: '23px', width: '25px' }} src={excelIconImage} />
//                                                 </Tooltip>
//                                             )
//                                     ) : (

//                                         <img style={{ marginLeft: '5px', height: '23px', width: '25px', cursor: 'pointer' }} src={excelIconImage} />

//                                     )
//                                 }
//                             </td>
//                         </tr>
//                     );
//                 })}
//                 {loaderForTable ? (
//                     <tr>
//                         <td
//                             colSpan={4}
//                             style={{
//                                 color: "black",
//                                 textAlign: "center",
//                                 fontWeight: "bold",
//                             }}
//                         >
//                             Loading…Please wait
//                         </td>
//                     </tr>
//                 ) : recordForLogTable?.length === 0 ? (
//                     <tr>
//                         <td colSpan={4} style={{ color: "red", textAlign: "center" }}>
//                             No Data Found!
//                         </td>
//                     </tr>
//                 ) : null}
//             </tbody> */}
//         </table>
//     </div>
// </BoxWrapper>
// );
// };

const DashboardCard = ({ title, value, icon, iconColor }) => {
    return (
        <Card
            sx={{
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                borderRadius: 4,
                padding: 3,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'linear-gradient(135deg, #ffffff 0%, #e3e3e3 100%)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease',
                '&:hover': {
                    transform: 'scale(1.03)',
                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
                },
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 15,
                    right: 15,
                    backgroundColor: iconColor,
                    width: 42,
                    height: 42,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '50%',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                }}
            >
                {icon}
            </Box>
            <Typography
                variant="h7"
                sx={{
                    fontWeight: 600,
                    color: '#1e293b',
                    textTransform: 'capitalize',
                    fontFamily: "'Poppins', sans-serif",
                }}
            >
                {title}
            </Typography>
            <Typography variant="h6" sx={{ marginTop: 1, fontWeight: 700 }}>
                {value}
            </Typography>
        </Card>
    );
};


const columns = (handleStatusChange, recordStatuses,) => [
    {
        field: 'record_type',
        headerName: 'Record Type',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'legal_name',
        headerName: 'Legal Name',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'stin',
        headerName: 'GSTIN',
        flex: 1,
        minWidth: 200,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'inum',
        headerName: 'Invoice Number',
        flex: 0.7,
        minWidth: 120,
        pinned: 'left',
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'inv_typ',
        headerName: 'Invoice Type',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'idt',
        headerName: 'Invoice Date',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'val',
        headerName: 'Invoice Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'rtnprd',
        headerName: 'Source Return Period',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'srcfilstatus',
        headerName: 'Source Filing Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'prev_action',
        headerName: 'Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
        renderCell: (params) => {
            return <span>{params.row.prev_action || ''}</span>;
        },
    },
    // {
    //     field: 'action',
    //     headerName: 'Status',
    //     width: 150,
    //     editable: (params) => params.row.srcfilstatus !== 'Not Filed', // Disable editing if srcfilstatus is "Not Filed"
    //     renderCell: (params) => {
    //         const isDisabled = params.row.srcfilstatus === 'Not Filed';
    //         return (
    //             <Select
    //                 value={recordStatuses[params.row.ID] || ''}
    //                 onChange={(event) => handleStatusChange(params.row.ID, event.target.value)}
    //                 disabled={isDisabled} // Disable dropdown if srcfilstatus is "Not Filed"
    //                 sx={{ width: '100%' }}
    //             >
    //                 <MenuItem value="Accepted">Accepted</MenuItem>
    //                 <MenuItem value="Pending">Pending</MenuItem>
    //                 <MenuItem value="Rejected">Rejected</MenuItem>
    //                 <MenuItem value="No Action">No Action</MenuItem>
    //             </Select>
    //         );
    //     },
    // },
  // {
  //   field: "action",
  //   headerName: "Actions",
  //   flex: 1,
  //   minWidth: 120,
  //   align: "center",
  //   headerAlign: "center",
  //   filterable: false,
  //   sortable: false,
  //   editable: true,
  //   renderCell: (params) => (
  //     <FormControl size="small" sx={{ minWidth: 100 }}>
  //       <Select
  //         value={recordStatuses[params.row.ID] || ""}
  //         onChange={(e) => handleStatusChange(params.row.ID, e.target.value)}
  //         sx={{ fontSize: "0.875rem" }}
  //       >
  //         <MenuItem value="" disabled>
  //           Select
  //         </MenuItem>
  //         <MenuItem value="Pending">Pending</MenuItem>
  //         <MenuItem value="Accepted">Accepted</MenuItem>
  //         <MenuItem value="Rejected">Rejected</MenuItem>
  //         <MenuItem value="No Action">No Action</MenuItem>
  //       </Select>
  //     </FormControl>
  //   ),
  // },

{
  field: "action",
  headerName: "Actions",
        flex: 1,
        minWidth: 120,
        align: 'center',
        headerAlign: 'center',
        filterable: false,
        sortable: false,
        editable: true,
        renderCell: (params) => (
            <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select
        value={recordStatuses[params.row.ID] || ""}
                    onChange={(e) => handleStatusChange(params.row.ID, e.target.value)}
        sx={{ fontSize: "0.875rem" }}
                >
        <MenuItem value="" disabled>
          Select
        </MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Accepted">Accepted</MenuItem>
        <MenuItem
          value="Rejected"
          disabled={params.row.record_type === "IMPG"}
        >
          Rejected
        </MenuItem>
                    <MenuItem value="No Action">No Action</MenuItem>
                </Select>
            </FormControl>
        ),
    },
];


const acceptColumns = [
   {
    field: "record_type",
    headerName: "Record Type",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTIN_of_Supplier",
    headerName: "GSTIN of Supplier",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Trade_Legal_name",
    headerName: "Trade/Legal name",
    flex: 1,
    minWidth: 200,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Number_Credit_Note_Number_Debit_Note_Number",
    headerName: "Invoice Number",
    flex: 0.7,
    minWidth: 120,
    pinned: "left",
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Type_Debit_Note_Supply_Type_Credit_Note_Supply_Type",
    headerName: "Invoice Type",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Date_Credit_Note_Date_Debit_Note_Date",
    headerName: "Invoice Date",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Value_Credit_Note_Value_Debit_Note_Value",
    headerName: "Invoice Value",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Source_Return_Period",
    headerName: "Source Return Period",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Source_Filing_Status",
    headerName: "Source Filing Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Status",
    headerName: "Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTR_2B_Recon_Remarks",
    headerName: "IMS Recon Remarks",
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },

];

const rejectColumns = [
    {
    field: "record_type",
    headerName: "Record Type",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTIN_of_Supplier",
    headerName: "GSTIN of Supplier",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Trade_Legal_name",
    headerName: "Trade/Legal name",
    flex: 1,
    minWidth: 200,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Number_Credit_Note_Number_Debit_Note_Number",
    headerName: "Invoice Number",
    flex: 0.7,
    minWidth: 120,
    pinned: "left",
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Type_Debit_Note_Supply_Type_Credit_Note_Supply_Type",
    headerName: "Invoice Type",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Date_Credit_Note_Date_Debit_Note_Date",
    headerName: "Invoice Date",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Value_Credit_Note_Value_Debit_Note_Value",
    headerName: "Invoice Value",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Source_Return_Period",
    headerName: "Source Return Period",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Source_Filing_Status",
    headerName: "Source Filing Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Status",
    headerName: "Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTR_2B_Recon_Remarks",
    headerName: "IMS Recon Remarks",
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },

];
const imsReconColumns = [
    {
    field: "record_type",
    headerName: "Record Type",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTIN_of_Supplier",
    headerName: "GSTIN of Supplier",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Trade_Legal_name",
    headerName: "Trade/Legal name",
    flex: 1,
    minWidth: 200,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Number",
    headerName: "Invoice Number",
    flex: 0.7,
    minWidth: 120,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Type",
    headerName: "Invoice Type",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Date",
    headerName: "Invoice Date",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Value",
    headerName: "Invoice Value",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Status",
    headerName: "Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
];

const pendingColumns = [
    {
    field: "record_type",
    headerName: "Record Type",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTIN_of_Supplier",
    headerName: "GSTIN of Supplier",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Trade_Legal_name",
    headerName: "Trade/Legal name",
    flex: 1,
    minWidth: 200,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Number_Credit_Note_Number_Debit_Note_Number",
    headerName: "Invoice Number",
    flex: 0.7,
    minWidth: 120,
    pinned: "left",
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Type_Debit_Note_Supply_Type_Credit_Note_Supply_Type",
    headerName: "Invoice Type",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Date_Credit_Note_Date_Debit_Note_Date",
    headerName: "Invoice Date",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Value_Credit_Note_Value_Debit_Note_Value",
    headerName: "Invoice Value",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Source_Return_Period",
    headerName: "Source Return Period",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Source_Filing_Status",
    headerName: "Source Filing Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Status",
    headerName: "Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTR_2B_Recon_Remarks",
    headerName: "IMS Recon Remarks",
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },

];

const noactionColumns = [
    {
    field: "record_type",
    headerName: "Record Type",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTIN_of_Supplier",
    headerName: "GSTIN of Supplier",
    flex: 1,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Trade_Legal_name",
    headerName: "Trade/Legal name",
    flex: 1,
    minWidth: 200,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Number_Credit_Note_Number_Debit_Note_Number",
    headerName: "Invoice Number",
    flex: 0.7,
    minWidth: 120,
    pinned: "left",
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Type_Debit_Note_Supply_Type_Credit_Note_Supply_Type",
    headerName: "Invoice Type",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Date_Credit_Note_Date_Debit_Note_Date",
    headerName: "Invoice Date",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Invoice_Value_Credit_Note_Value_Debit_Note_Value",
    headerName: "Invoice Value",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Source_Return_Period",
    headerName: "Source Return Period",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Source_Filing_Status",
    headerName: "Source Filing Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "Status",
    headerName: "Status",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    filterable: true,
  },
  {
    field: "GSTR_2B_Recon_Remarks",
    headerName: "IMS Recon Remarks",
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },

];


const CustomToolbar = ({
  activeTab,
  onSubmit,
  onSave,
  isSubmitDisabled,
  isSaveDisabled,
  onError,
  errorLogId,
  onReset,
  isResetDisabled,
  onRunReport,
  showPushPopup,
  setShowPushPopup,
  pushStatus,
  pushStatusLoading,
  onCheckPushStatus,
  bulkStatus,
  onBulkStatusChange,
  bulkDropdownEnabled,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      height: "60px",
      flexWrap: "wrap",
      gap: 1,
      padding: "3px 10px",
      backgroundColor: "#ffffff",
      borderRadius: "4px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    }}
  >
    <Box sx={{ display: "flex", gap: 1 }}>
      <GridToolbarColumnsButton
        sx={{
          borderColor: "#1976d2",
          color: "#1976d2",
          borderRadius: "4px",
          padding: "2px 4px",
          "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
        }}
      />
      <GridToolbarFilterButton
        sx={{
          borderColor: "#1976d2",
          color: "#1976d2",
          borderRadius: "4px",
          padding: "2px 4px",
          "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
        }}
        PopperProps={{ style: { zIndex: 1300 } }}
      />
      <GridToolbarDensitySelector
        sx={{
          borderColor: "#1976d2",
          color: "#1976d2",
          borderRadius: "4px",
          padding: "2px 4px",
          "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
        }}
      />
    </Box>

    {activeTab === "imsReport" && (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <Select
            value={bulkStatus}
            displayEmpty
            onChange={(e) => onBulkStatusChange(e.target.value)}
            disabled={!bulkDropdownEnabled}
            sx={{ height: "36px", fontSize: "13px" }}
          >
            <MenuItem value="" disabled>
              Bulk Status
            </MenuItem>
            <MenuItem value="Accepted">Accepted</MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Rejected">Rejected</MenuItem>
            <MenuItem value="No Action">No Action</MenuItem>
          </Select>
        </FormControl>

        {/* ── EXISTING: Error Report ── */}
        <button
          className="button-outlined-primary"
          style={{
            width: "auto", height: "36px", padding: "0 16px",
            whiteSpace: "nowrap", fontSize: "14px",
            opacity: errorLogId === null ? 0.5 : 1,
            cursor: errorLogId === null ? "not-allowed" : "pointer",
          }}
          onClick={onError}
          disabled={errorLogId === null}
        >
          Error Report
        </button>

        {/* Reset */}
        <button
          className="button-outlined-primary"
          style={{
            height: "36px", padding: "0 12px",
            opacity: isResetDisabled ? 0.5 : 1,
            cursor: isResetDisabled ? "not-allowed" : "pointer",
          }}
          onClick={onReset}
          disabled={isResetDisabled}
        >
          Reset
        </button>

        {/* Save */}
        <button
          className="button-outlined-primary"
          style={{ height: "36px", padding: "0 12px" }}
          onClick={onSave}
        >
          Save
        </button>

        {/* ── Push + always-visible status ── */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                <button
                    className="button-outlined-primary"
            style={{ height: "36px", padding: "0 16px", whiteSpace: "nowrap" }}
            onClick={() => {
              onSubmit();
              onCheckPushStatus();
            }}
                >
                    Push
                </button>

          {/* Always-visible status pill */}
          {pushStatusLoading ? (
            <div style={{
              display: "flex", alignItems: "center", gap: "6px",
              padding: "4px 12px",
              background: "#e8f4fd",
              border: "1px solid #90caf9",
              borderRadius: "20px",
              fontSize: "12px", color: "#1565c0"
            }}>
              <CircularProgress size={10} style={{ color: "#1565c0" }} />
              <span style={{ fontWeight: 500 }}>Checking...</span>
            </div>

          ) : pushStatus ? (() => {
            const s = pushStatus.status?.toLowerCase();

            const config = {
              success: { bg: "#f0fdf4", border: "#86efac", dot: "#22c55e", text: "#15803d", label: "Success" },
              pass: { bg: "#f0fdf4", border: "#86efac", dot: "#22c55e", text: "#15803d", label: "Success" },
              processing: { bg: "#eff6ff", border: "#93c5fd", dot: "#3b82f6", text: "#1d4ed8", label: "Processing" },
              "partial success": { bg: "#fffbeb", border: "#fcd34d", dot: "#f59e0b", text: "#b45309", label: "Partial Success" },
              error: { bg: "#fef2f2", border: "#fca5a5", dot: "#ef4444", text: "#b91c1c", label: "Error" },
            };

            const c = config[s] || {
              bg: "#f8f9fa", border: "#dee2e6",
              dot: "#9ca3af", text: "#6b7280",
              label: pushStatus.status
            };

            const showRefresh = s === "processing" || s === "partial success";

            return (
              <div style={{
                display: "flex", alignItems: "center", gap: "6px",
                padding: "4px 12px",
                background: c.bg,
                border: `1px solid ${c.border}`,
                borderRadius: "20px",
                minWidth: "150px",
              }}>

                {/* Dot — CircularProgress for processing, solid dot for others */}
                {s === "processing" ? (
                  <CircularProgress
                    size={8}
                    style={{ color: c.dot, flexShrink: 0 }}
                  />
                ) : (
                  <span style={{
                    width: 8, height: 8, borderRadius: "50%",
                    flexShrink: 0, background: c.dot,
                  }} />
                )}

                <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.3 }}>
                  <span style={{ fontSize: "12px", fontWeight: 600, color: c.text }}>
                    {c.label}
                  </span>
                  {pushStatus.date_time && (
                    <span style={{ fontSize: "11px", color: "#888" }}>
                      🕐 {pushStatus.date_time}
                    </span>
                  )}
                </div>

                {/* Refresh button for processing & partial success */}
                {showRefresh && (
                  <button
                    title="Refresh status"
                    onClick={onCheckPushStatus}
                    style={{
                      background: "none", border: "none",
                      cursor: "pointer", fontSize: "20px",
                      color: c.dot, padding: "0", marginLeft: "2px",
                      lineHeight: 1,
                    }}
                  >
                    ↻
                  </button>
                )}
              </div>
            );
          })() : (
            <div style={{
              padding: "4px 12px",
              background: "#f8f9fa",
              border: "1px solid #dee2e6",
              borderRadius: "20px",
              fontSize: "12px",
              color: "#9ca3af",
              fontWeight: 500,
            }}>
              No push yet
            </div>
          )}

        </div>
            </div>
        )}
    </Box>
);

// const CustomToolbar = ({
//   activeTab,
//   onSubmit,
//   onSave,
//   isSubmitDisabled,
//   isSaveDisabled,
//   onError,
//   errorLogId,
//   onReset,
//   isResetDisabled,
//   onRunReport,
//   showPushPopup,
//   setShowPushPopup,
//   pushStatus,
//   pushStatusLoading,
//   onCheckPushStatus,
// }) => (
//   <Box
//     sx={{
//       display: "flex",
//       justifyContent: "space-between",
//       width: "100%",
//       height: "60px",
//       flexWrap: "wrap",
//       gap: 1,
//       padding: "3px 10px",
//       backgroundColor: "#ffffff",
//       borderRadius: "4px",
//       boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//     }}
//   >
//     <Box sx={{ display: "flex", gap: 1 }}>
//       <GridToolbarColumnsButton
//         sx={{
//           borderColor: "#1976d2",
//           color: "#1976d2",
//           borderRadius: "4px",
//           padding: "2px 4px",
//           "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
//         }}
//       />
//       <GridToolbarFilterButton
//         sx={{
//           borderColor: "#1976d2",
//           color: "#1976d2",
//           borderRadius: "4px",
//           padding: "2px 4px",
//           "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
//         }}
//         PopperProps={{
//           style: { zIndex: 1300 },
//         }}
//       />
//       <GridToolbarDensitySelector
//         sx={{
//           borderColor: "#1976d2",
//           color: "#1976d2",
//           borderRadius: "4px",
//           padding: "2px 4px",
//           "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
//         }}
//       />
//     </Box>
//     {activeTab === "imsReport" && (
//       <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//         {/* EXISTING BUTTONS BELOW */}
//         <button
//           className="button-outlined-primary"
//           style={{
//             width: "auto",
//             height: "36px",
//             padding: "0 16px",
//             whiteSpace: "nowrap",
//             fontSize: "14px",
//             opacity: errorLogId === null ? 0.5 : 1,
//             cursor: errorLogId === null ? "not-allowed" : "pointer",
//           }}
//           onClick={onError}
//           disabled={errorLogId === null}
//         >
//           Error Report
//         </button>
//         <button
//           className="button-outlined-primary"
//           style={{
//             width: "42%",
//             height: "59%",
//             marginTop: "1%",
//             opacity: isResetDisabled ? 0.5 : 1, // Use isResetDisabled for opacity
//             cursor: isResetDisabled ? "not-allowed" : "pointer",
//           }}
//           onClick={onReset}
//           disabled={isResetDisabled} // Use isResetDisabled prop
//         >
//           Reset
//         </button>
//         <button
//           className="button-outlined-primary"
//           style={{
//             width: "42%",
//             height: "59%",
//             marginTop: "1%",
//             // opacity: isSaveDisabled ? 1 : 1,
//             // cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
//           }}
//           onClick={onSave}
//         // disabled={isSaveDisabled}
//         >
//           Save
//         </button>
//         <button
//           className="button-outlined-primary"
//           style={{
//             width: "42%",
//             height: "59%",
//             marginTop: "1%",
//             // opacity: isSubmitDisabled ? 1 : 1,
//             // cursor: isSubmitDisabled ? 'not-allowed' : 'pointer',
//           }}
//           onClick={onSubmit}
//         // disabled={isSubmitDisabled}
//         >
//           Push
//         </button>
//         <button
//           className="button-outlined-primary"
//           style={{ width: "60", height: "59", marginTop: "1%" }}>
//           Status:

//         </button>
//         <button
//           className="button-outlined-primary"
//           style={{ width: "42", height: "59", marginTop: "1%" }}>
//           Refresh

//         </button>
//       </div>
//     )}
//   </Box>
// );

const CustomNoRowsOverlay = () => {
    console.log('Rendering CustomNoRowsOverlay');
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontSize: '16px',
                fontWeight: 'medium',
                color: 'text.secondary',
            }}
        >
            No Data Available
        </Box>
    );
};
const IMSRecon = ({
  recordForImsReconTable,
  loaderForTable,
  getApiImsRecon,
  ims_recon_id,
  activeTab,
  onClickExportImsRecon,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [filteredData, setFilteredData] = useState(recordForImsReconTable);

  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    setFilteredData(recordForImsReconTable);
  }, [recordForImsReconTable]);

  const handleSearchInputChange = (event) => {
    const searchValue = event.target.value;
    setSearchInput(searchValue);

    if (!searchValue.trim()) {
      setFilteredData(recordForImsReconTable);
      return;
    }

    const query = searchValue.trim().toLowerCase();
    const filtered = recordForImsReconTable.filter((invoice) => {
      return (
        String(invoice.GSTIN || "")
          .toLowerCase()
          .includes(query) ||
        String(invoice.Vendor_Name || "")
          .toLowerCase()
          .includes(query) ||
        String(invoice.DOC_NUMBER || "")
          .toLowerCase()
          .includes(query) ||
        String(invoice.TYPE || "")
          .toLowerCase()
          .includes(query) ||
        String(invoice.DATE || "")
          .toLowerCase()
          .includes(query)
      );
    });
    setFilteredData(filtered);
  };

  // Format number for Indian locale
  const formatNumber = (num) => {
    if (num === undefined || num === null) return "-";
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleExportClick = async () => {
    if (isExporting) return;
    setIsExporting(true);
    try {
      await onClickExportImsRecon();
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <BoxWrapper
      boxTitle="IMS Reconciliation Report"
      enableSearchInput={true}
      searchInputPlaceholder="Search..."
      searchInputOnchange={handleSearchInputChange}
      enableAddButton={true}
            // addButtonLabel="EXPORT"
      addButtonLabel={isExporting ? "EXPORTING..." : "EXPORT"}
      addButtonDisabled={isExporting}
      addButtonHandlerFn={handleExportClick}
    >
      <div
        style={{
          maxHeight: "500px",
          overflow: "auto",
          position: "relative",
        }}
      >
        {loaderForTable && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 100,
            }}
          >
            <CircularProgress size={40} style={{ color: "#607d8b" }} />
          </div>
        )}

        <table
          style={{
            tableLayout: "fixed",
            fontFamily: '"Dosis", sans-serif',
            border: "3px solid #ddd",
            width: "300%",
            borderCollapse: "collapse",
            borderRadius: "20px",
          }}
        >
          <thead>
            <tr>
              <th
                rowSpan={2}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c4d0d9",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                GSTIN
              </th>
              <th
                rowSpan={2}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c4d0d9",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                VENDOR NAME
              </th>
              <th
                rowSpan={2}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c4d0d9",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                DOC NUMBER
              </th>
              <th
                rowSpan={2}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c4d0d9",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                DATE
              </th>
              <th
                rowSpan={2}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c4d0d9",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                DOC TYPE
              </th>

              <th
                colSpan={6}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#ffcc66",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                AS PER BOOKS
              </th>
              <th
                colSpan={6}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c6ffb3",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                AS PER IMS
              </th>
              <th
                colSpan={2}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "ORANGE",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                DIFFERENCE
              </th>
              <th
                rowSpan={2}
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "-1px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c4d0d9",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                REMARKS
              </th>
            </tr>
            <tr
              style={{
                top: "44px",
              }}
            >
              {/* As per Books columns */}
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#ffcc66",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                TAXABLE VALUE
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#ffcc66",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                CGST
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#ffcc66",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                SGST
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#ffcc66",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                IGST
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#ffcc66",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                CESS
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#ffcc66",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                TOTAL AMOUNT
              </th>

              {/* As per GSTR2B columns */}
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c6ffb3",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                TAXABLE VALUE
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c6ffb3",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                CGST
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c6ffb3",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                SGST
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c6ffb3",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                IGST
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c6ffb3",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                CESS
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "#c6ffb3",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                TOTAL AMOUNT
              </th>

              {/* Difference columns */}
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "ORANGE",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                TAXABLE VALUE
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  position: "sticky",
                  top: "44px",
                  zIndex: 50,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                  backgroundColor: "ORANGE",
                  color: "black",
                  fontSize: "13px",
                }}
              >
                TOTAL AMOUNT
              </th>
            </tr>
          </thead>

          <tbody>
            {filteredData.length === 0 && !loaderForTable ? (
              <tr>
                <td
                  colSpan={20}
                  style={{
                    color: "red",
                    textAlign: "center",
                    padding: "20px",
                    border: "1px solid #ddd",
                  }}
                >
                  No Data Found!
                </td>
              </tr>
            ) : (
              filteredData.map((invoice, index) => (
                <tr key={invoice.PR_VOUCHER_ID || index}>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {invoice.GSTIN}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {invoice.Vendor_Name}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {invoice.DOC_NUMBER}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {invoice.DATE}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {invoice.TYPE}
                  </td>

                  {/* As per Books */}
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.Taxable_Value_Books)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.CGST_Books)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.SGST_Books)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.IGST_Books)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.Cess_Books)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.Total_Amount_Books)}
                  </td>

                  {/* As per GSTR2B */}
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.Taxable_Value_GSTR2B)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.CGST_GSTR2B)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.SGST_GSTR2B)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.IGST_GSTR2B)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.Cess_GSTR2B)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.Total_Amount_Books_GSTR2B)}
                  </td>

                  {/* Difference */}
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.Taxable_Value_Diff)}
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {formatNumber(invoice.Total_Amount_Diff)}
                  </td>

                  <td
                    style={{
                      color: "black",
                      padding: "8px",
                      textAlign: "center",
                      border: "1px solid #ddd",
                    }}
                  >
                    {invoice["Remarks 2"] || invoice["Remarks 1"] || "-"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </BoxWrapper>
  );
};


const IMSReport = ({
  recordForTable,
  loaderForTable,
  getApiImsReport,
  activeTab,
  errorLogId,
  setErrorLogId,
  ims_recon_id,
  tax_period,
  onRunReport,
  onCheckPushStatus,
  pushStatus,
  setPushStatus,
  pushStatusLoading,
}) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [areButtonsDisabled, setAreButtonsDisabled] = useState(false);
  const [isResetEnabled, setIsResetEnabled] = useState(false);

  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [bulkStatus, setBulkStatus] = useState("");

  // ── FIX: compare against unique ID count, not row count ──
 const totalUniqueIds = new Set(recordForTable.map((row) => row.ID)).size;

const isAnySelected = rowSelectionModel.length > 0;

const handleBulkStatusChange = (newStatus) => {
  const selectedRows = recordForTable.filter((row) =>
    rowSelectionModel.includes(row.ID)
  );
  const hasImpg = selectedRows.some((row) => row.record_type === "IMPG");
  const hasOthers = selectedRows.some((row) => row.record_type !== "IMPG");

  // Case 1: IMPG mixed with other record types -> block bulk update entirely
  // if (hasImpg && hasOthers) {
  //   setSnackbar({
  //     open: true,
  //     message:
  //       "Bulk status can't be updated: IMPG records are selected along with other record types. Please select only IMPG or only non-IMPG records.",
  //     severity: "warning",
  //   });
  //   return;
  // }

  // Case 2: Only IMPG selected, but trying to Reject -> not allowed
  if (hasImpg && newStatus === "Rejected") {
    setSnackbar({
      open: true,
      message: "IMPG records cannot be marked as Rejected.",
      severity: "warning",
    });
    return;
  }

  setBulkStatus(newStatus);
  setRecordStatuses((prev) => {
    const updated = { ...prev };
    rowSelectionModel.forEach((id) => {   // ✅ only selected row IDs
      updated[id] = newStatus;
    });
    return updated;
  });
  setIsSaved(false);
};

  const normalizeStatus = (status) => {
    if (!status) return "";
    const lowerStatus = status.toLowerCase();
    if (lowerStatus === "accepted") return "Accepted";
    if (lowerStatus === "pending") return "Pending";
    if (lowerStatus === "rejected") return "Rejected";
    if (lowerStatus === "no action") return "No Action";
    return "";
  };

    const statusToApiValue = (status) => {
        return status || '';
    };

    const [recordStatuses, setRecordStatuses] = useState(
        recordForTable.reduce((acc, row) => {
            acc[row.ID] = normalizeStatus(row.action);
            return acc;
        }, {})
    );

    const [isSaved, setIsSaved] = useState(false);

    useEffect(() => {
        const business_entity_id = localStorage.getItem("business_entity_id");
        const ims_recon_id = localStorage.getItem("ims_recon_id");
        axios
            .get(`/get_ims_refresh_api/${ims_recon_id}/${business_entity_id}`)
            .then((response) => {
                console.log('IMS Refresh API Response:', response.data);
                // Enable Reset button if is_reset_required is false
                if (response.data.is_reset_required === true) {
                    setIsResetEnabled(true);
                } else {
                    setIsResetEnabled(false);
                }
            })
            .catch((error) => {
                console.error('Error in IMS refresh API:', error);
            });
        setRecordStatuses((prev) =>
            recordForTable.reduce((acc, row) => {
                acc[row.ID] = prev[row.ID] || normalizeStatus(row.action);
                return acc;
            }, {})
        );
        // Reset isSaved when recordForTable changes
        setIsSaved(false);
           setRowSelectionModel([]);
    setBulkStatus("");
        // Enable Reset button if any record has is_required_true === true, else disable
        setIsResetEnabled(recordForTable.some((row) => row.is_required_true === true));
    }, [recordForTable]);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleStatusChange = (id, newStatus) => {
        console.log('handleStatusChange - ID:', id, 'New Status:', newStatus);
        setRecordStatuses((prev) => ({
            ...prev,
            [id]: newStatus,
        }));
        setIsSaved(false);
    };

    const handleSubmit = async () => {
        const business_entity_id = localStorage.getItem("business_entity_id");
        const ims_recon_id = localStorage.getItem("ims_recon_id");

        const payload = {
            business_entity_id: business_entity_id,
            ims_recon_id: ims_recon_id,
            tax_period: localStorage.getItem("tax_period"),
        };

        try {
            const res = await axios.post('/push_to_ims_portal', payload);
            console.log('IMS Accepted Report Response:', res.data);

      if (res.data.status.toLowerCase().includes("success")) {
        let message = "Records submitted successfully";
        setErrorLogId(null);
        if (res.data.status.includes("partial")) {
          message = "Records submitted partially";
          // ADDED: Fetch error_log_id for partial success
          axios
            .get(`/ims_reecon_log_summary/${business_entity_id}`)
            .then((response) => {
              if (response.data.data?.length > 0) {
                setErrorLogId(response.data.data[0].error_log_id);
              }
            })
            .catch((error) => {
              console.error("Error fetching error log ID:", error);
            });
        }
        let severity = "success";

                setSnackbar({
                    open: true,
                    message: message,
                    severity: severity,
                });

                setIsSaved(false);
        setAreButtonsDisabled(true);

                if (getApiImsReport) {
                    await getApiImsReport();
                }

                axios
                    .get(`/get_ims_refresh_api/${ims_recon_id}/${business_entity_id}`)
                    .then((response) => {
                        if (response.data.is_reset_required === true) {
                            setIsResetEnabled(true);
                        } else {
                            setIsResetEnabled(false);
                        }
                    })
                    .catch((error) => {
            console.error("Error in IMS refresh API:", error);
          });
      }
      else if (
        res.data.status.toLowerCase().includes("processing") ) {
        setSnackbar({
          open: true,
          message:
            "Request in progress on the government portal. Processing time: 1-6 hours",
          severity: "warning",
                    });

            } else if (res.data.status === "error") {
                setSnackbar({
                    open: true,
          message: res.data.message || "Error submitting IMS records",
          severity: "error",
        });
        // ADDED: Fetch error_log_id for error
        axios
          .get(`/ims_reecon_log_summary/${business_entity_id}`)
          .then((response) => {
            if (response.data.data?.length > 0) {
              setErrorLogId(response.data.data[0].error_log_id);
            }
          })
          .catch((error) => {
            console.error("Error fetching error log ID:", error);
                });
            } else {
                setSnackbar({
                    open: true,
                    message: 'Unexpected response status',
                    severity: 'error',
                });
            }
        } catch (error) {
            console.error('Error submitting IMS records:', error);
            setSnackbar({
                open: true,
                message: error.response?.data?.message || 'Error submitting IMS records',
                severity: 'error',
            });
        }
    };

    const handleSave = async () => {
        console.log('handleSave called with recordStatuses:', recordStatuses);
        console.log('recordForTable:', recordForTable);
        const business_entity_id = localStorage.getItem("business_entity_id");

        if (!recordForTable || recordForTable.length === 0) {
            console.log('recordForTable is empty or undefined');
            setSnackbar({
                open: true,
                message: 'No records available to save',
                severity: 'error',
            });
            return;
        }

        const changedRecords = recordForTable
      .filter(
        (row) =>
          recordStatuses[row.ID] &&
          recordStatuses[row.ID] !== normalizeStatus(row.action),
      )
            .map((row) => ({
                record_type: row.record_type,
                ID: row.ID,
                stin: row.stin,
                inum: row.inum,
                inv_typ: row.inv_typ,
                action: statusToApiValue(recordStatuses[row.ID]),
                srcform: row.srcform || 'R1',
                rtnprd: row.rtnprd,
                idt: row.idt,
                val: row.val,
                pos: row.pos || '29',
                txval: row.txval || row.val,
                iamt: row.iamt || 0,
                camt: row.camt || 0,
                samt: row.samt || 0,
                prev_action: row.prev_action,
                cess: row.cess || 0,
            }));

        if (changedRecords.length === 0) {
            setSnackbar({
                open: true,
                message: 'No changes to save',
                severity: 'info',
            });
            return;
        }

        const payload = {
            business_entity_id: business_entity_id,
            records: changedRecords,
        };

        try {
            const res = await axios.post('/save_ims_status', payload);
            console.log('IMS Save Response:', res.data);
            setSnackbar({
                open: true,
                message: 'Records saved successfully',
                severity: 'success',
            });
            setAreButtonsDisabled(true); // Disable Push and Save buttons on success
            if (getApiImsReport) {
                await getApiImsReport();
            }
        } catch (error) {
            console.error('Error saving IMS records:', error);
            setSnackbar({
                open: true,
                message: error.response?.data?.message || 'Error saving IMS records',
                severity: 'error',
            });
        }
    };

    const handleReset = async () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            ims_recon_id: localStorage.getItem("ims_recon_id")
        };

        try {
            const res = await axios.post('/reset_ims_data_via_api', payload);
            console.log('IMS Reset Report Response:', res.data);
            if (res.data.status === "success") {
                const statusCheckStatus = res.data.status_check?.status;

                let message = res.data.message || 'Records reset successfully';
                let severity = 'success';

                if (statusCheckStatus) {
                    switch (statusCheckStatus) {
                        case 'success':
                            message = 'Records processed successfully';
                            severity = 'success';
                            break;
                        case 'error':
                            message = 'Status check failed';
                            severity = 'error';
                            break;
                        default:
                            message = `Status: ${statusCheckStatus}`;
                            severity = 'info';
                    }
                }

                setSnackbar({
                    open: true,
                    message: message,
                    severity: severity,
                });

                setAreButtonsDisabled(false); // Re-enable Push and Save buttons on successful reset

                if (getApiImsReport) {
                    await getApiImsReport();
                }
            } else if (res.data.status === "error") {
                setSnackbar({
                    open: true,
                    message: res.data.message || 'Error resetting IMS records',
                    severity: 'error',
                });
            } else {
                setSnackbar({
                    open: true,
                    message: 'Unexpected response status',
                    severity: 'error',
                });
            }
        } catch (error) {
            console.error('Error resetting IMS records:', error);
            setSnackbar({
                open: true,
                message: error.response?.data?.message || 'Error resetting IMS records',
                severity: 'error',
            });
        }
    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleErrorReport = async () => {
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `IMS Error Report.xlsx`;
        const payload = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      error_log_id: errorLogId,
        };

        axios
            .post(`/generate_error_log_excel_report`, payload)
            .then((res) => {
                if (res.data.status === "pass") {
                    downloadBase64File(contentType, res.data.file, filename);
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Unable to download",
                        severity: 'error'
                    });
                }
            })
            .catch((error) => {
                setSnackbar({
                    open: true,
                    message: error.response?.data?.description || "Server error, please try again later",
                    severity: 'error'
                });
            });
    };

    return (
        <>
            <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
<DataGridPro
          rows={recordForTable}
          columns={columns(handleStatusChange, recordStatuses)}
          getRowId={(row) => row.ID}
          loading={loaderForTable}
          errorLogId={errorLogId}           
          checkboxSelection
          selectionModel={rowSelectionModel}
          onSelectionModelChange={(newSelection) => setRowSelectionModel(newSelection)}
          disableSelectionOnClick
          sx={{
            maxHeight: "65vh",
            "& .MuiDataGrid-columnHeaders": {
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
              textAlign: "right",
              zIndex: 1000,
            },
            "& .MuiDataGrid-columnHeader": {
              position: "relative",
              textAlign: "right",
              width: "100%",
              fontWeight: "bold",
              backgroundColor: "#607d8b",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: "#fff",
            },
            "& .MuiDataGrid-sortIcon": {
              opacity: "inherit !important",
            },
            "& .MuiDataGrid-iconButtonContainer": {
              visibility: "visible",
            },
            "& .MuiDataGrid-menuIconButton": {
              opacity: "1 !important",
              visibility: "visible !important",
              display: "flex !important",
            },
            "& .MuiDataGrid-columnHeaderIcon": {
              color: "#fff",
            },
            "& .MuiDataGrid-columnHeader .MuiIconButton-root": {
              color: "#fff",
            },
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: "#f9f9f9",
            },
            "& .MuiDataGrid-row:nth-of-type(even)": {
              backgroundColor: "#ffffff",
            },
            "& .MuiDataGrid-cell": {
              padding: "8px",
              textAlign: "center",
            },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: "#f0f0f0",
            },
            "& .MuiCheckbox-root": {
              color: "#1976d2",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#d3e3fc",
              cursor: "pointer",
            },
          }}
          components={{
            Toolbar: () => (
              <CustomToolbar
                activeTab={activeTab}
                onSubmit={handleSubmit}
                onSave={handleSave}
                onReset={handleReset}
                isSubmitDisabled={areButtonsDisabled}
                isSaveDisabled={areButtonsDisabled}
                isResetDisabled={!isResetEnabled}
                errorLogId={errorLogId}
                onError={handleErrorReport}
                onRunReport={onRunReport}
                onCheckPushStatus={onCheckPushStatus}
                pushStatus={pushStatus}
                pushStatusLoading={pushStatusLoading}
                bulkStatus={bulkStatus}
                onBulkStatusChange={handleBulkStatusChange}
              bulkDropdownEnabled={isAnySelected}
              />
            ),
            NoRowsOverlay: CustomNoRowsOverlay,
          }}
         />
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};


// const IMSReport = ({ recordForTable, loaderForTable, getApiImsReport, activeTab, errorLogId, ims_recon_id, tax_period }) => {
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: '',
//         severity: 'info',
//     });
//     const [areButtonsDisabled, setAreButtonsDisabled] = useState(false); // New state for button disable/enable

//     // Normalize status values to match dropdown options (case-sensitive)
//     const normalizeStatus = (status) => {
//         if (!status) return '';
//         const lowerStatus = status.toLowerCase();
//         if (lowerStatus === 'accepted') return 'Accepted';
//         if (lowerStatus === 'pending') return 'Pending';
//         if (lowerStatus === 'rejected') return 'Rejected';
//         if (lowerStatus === 'no action') return 'No Action';
//         return '';
//     };

//     const statusToApiValue = (status) => {
//         return status || '';
//     };

//     const [recordStatuses, setRecordStatuses] = useState(
//         recordForTable.reduce((acc, row) => {
//             acc[row.ID] = normalizeStatus(row.action);
//             return acc;
//         }, {})
//     );

//     const [isSaved, setIsSaved] = useState(false);

//     useEffect(() => {
//         setRecordStatuses((prev) =>
//             recordForTable.reduce((acc, row) => {
//                 acc[row.ID] = prev[row.ID] || normalizeStatus(row.action);
//                 return acc;
//             }, {})
//         );
//         // Reset isSaved when recordForTable changes, as new data means changes need to be saved again
//         setIsSaved(false);
//     }, [recordForTable]);

//     const handleCloseSnackbar = () => {
//         setSnackbar({ ...snackbar, open: false });
//     };

//     const handleStatusChange = (id, newStatus) => {
//         console.log('handleStatusChange - ID:', id, 'New Status:', newStatus);
//         setRecordStatuses((prev) => ({
//             ...prev,
//             [id]: newStatus,
//         }));
//         setIsSaved(false);
//     };

//     const handleSubmit = async () => {
//         const payload = {
//             business_entity_id: localStorage.getItem("business_entity_id"),
//             ims_recon_id: localStorage.getItem("ims_recon_id"),
//             tax_period: localStorage.getItem("tax_period"),
//         };

//         try {
//             const res = await axios.post('/push_to_ims_portal', payload);
//             console.log('IMS Accepted Report Response:', res.data);

//             if (res.data.status === "success") {
//                 const statusCheckStatus = res.data.status_check?.status;

//                 let message = res.data.message || 'Records submitted successfully';
//                 let severity = 'success';

//                 if (statusCheckStatus) {
//                     switch (statusCheckStatus) {
//                         case 'success':
//                             message = 'Records processed successfully';
//                             severity = 'success';
//                             break;
//                         case 'error':
//                             message = 'Status check failed';
//                             severity = 'error';
//                             break;
//                         default:
//                             message = `Status: ${statusCheckStatus}`;
//                             severity = 'info';
//                     }
//                 }

//                 setSnackbar({
//                     open: true,
//                     message: message,
//                     severity: severity,
//                 });

//                 setIsSaved(false);
//                 setAreButtonsDisabled(true); // Disable Push and Save buttons on success

//                 if (getApiImsReport) {
//                     await getApiImsReport();
//                 }
//             } else if (res.data.status === "error") {
//                 setSnackbar({
//                     open: true,
//                     message: res.data.message || 'Error submitting IMS records',
//                     severity: 'error',
//                 });
//             } else {
//                 setSnackbar({
//                     open: true,
//                     message: 'Unexpected response status',
//                     severity: 'error',
//                 });
//             }
//         } catch (error) {
//             console.error('Error submitting IMS records:', error);
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || 'Error submitting IMS records',
//                 severity: 'error',
//             });
//         }
//     };

//     const handleSave = async () => {
//         console.log('handleSave called with recordStatuses:', recordStatuses);
//         console.log('recordForTable:', recordForTable);
//         const business_entity_id = localStorage.getItem("business_entity_id");

//         if (!recordForTable || recordForTable.length === 0) {
//             console.log('recordForTable is empty or undefined');
//             setSnackbar({
//                 open: true,
//                 message: 'No records available to save',
//                 severity: 'error',
//             });
//             return;
//         }

//         // Filter records where the status has changed
//         const changedRecords = recordForTable
//             .filter((row) => recordStatuses[row.ID] && recordStatuses[row.ID] !== normalizeStatus(row.action))
//             .map((row) => ({
//                 record_type: row.record_type,
//                 ID: row.ID,
//                 stin: row.stin,
//                 inum: row.inum,
//                 inv_typ: row.inv_typ,
//                 action: statusToApiValue(recordStatuses[row.ID]),
//                 srcform: row.srcform || 'R1',
//                 rtnprd: row.rtnprd,
//                 idt: row.idt,
//                 val: row.val,
//                 pos: row.pos || '29',
//                 txval: row.txval || row.val,
//                 iamt: row.iamt || 0,
//                 camt: row.camt || 0,
//                 samt: row.samt || 0,
//                 prev_action: row.prev_action,
//                 cess: row.cess || 0,
//             }));

//         if (changedRecords.length === 0) {
//             setSnackbar({
//                 open: true,
//                 message: 'No changes to save',
//                 severity: 'info',
//             });
//             return;
//         }

//         const payload = {
//             business_entity_id: business_entity_id,
//             records: changedRecords,
//         };

//         try {
//             const res = await axios.post('/save_ims_status', payload);
//             console.log('IMS Save Response:', res.data);
//             setSnackbar({
//                 open: true,
//                 message: 'Records saved successfully',
//                 severity: 'success',
//             });
//             setAreButtonsDisabled(true); // Disable Push and Save buttons on success
//             if (getApiImsReport) {
//                 await getApiImsReport();
//             }
//         } catch (error) {
//             console.error('Error saving IMS records:', error);
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || 'Error saving IMS records',
//                 severity: 'error',
//             });
//         }
//     };

//     const handleReset = async () => {
//         const payload = {
//             business_entity_id: localStorage.getItem('business_entity_id'),
//             ims_recon_id: localStorage.getItem("ims_recon_id")
//         };

//         try {
//             const res = await axios.post('/reset_ims_data_via_api', payload);
//             console.log('IMS Reset Report Response:', res.data);
//             if (res.data.status === "success") {
//                 const statusCheckStatus = res.data.status_check?.status;

//                 let message = res.data.message || 'Records reset successfully';
//                 let severity = 'success';

//                 if (statusCheckStatus) {
//                     switch (statusCheckStatus) {
//                         case 'success':
//                             message = 'Records processed successfully';
//                             severity = 'success';
//                             break;
//                         case 'error':
//                             message = 'Status check failed';
//                             severity = 'error';
//                             break;
//                         default:
//                             message = `Status: ${statusCheckStatus}`;
//                             severity = 'info';
//                     }
//                 }

//                 setSnackbar({
//                     open: true,
//                     message: message,
//                     severity: severity,
//                 });

//                 setAreButtonsDisabled(false); // Re-enable Push and Save buttons on successful reset

//                 if (getApiImsReport) {
//                     await getApiImsReport();
//                 }
//             } else if (res.data.status === "error") {
//                 setSnackbar({
//                     open: true,
//                     message: res.data.message || 'Error resetting IMS records',
//                     severity: 'error',
//                 });
//             } else {
//                 setSnackbar({
//                     open: true,
//                     message: 'Unexpected response status',
//                     severity: 'error',
//                 });
//             }
//         } catch (error) {
//             console.error('Error resetting IMS records:', error);
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || 'Error resetting IMS records',
//                 severity: 'error',
//             });
//         }
//     };

//     const downloadBase64File = (contentType, base64Data, fileName) => {
//         const linkSource = `data:${contentType};base64,${base64Data}`;
//         const downloadLink = document.createElement("a");
//         downloadLink.href = linkSource;
//         downloadLink.download = fileName;
//         downloadLink.click();
//     };

//     const handleErrorReport = async () => {
//         const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
//         const filename = `IMS Error Report.xlsx`;
//         const payload = {
//             business_entity_id: localStorage.getItem("business_entity_id")
//         };

//         axios
//             .post(`/generate_error_log_excel_report`, payload)
//             .then((res) => {
//                 if (res.data.status === "pass") {
//                     downloadBase64File(contentType, res.data.file, filename);
//                 } else {
//                     setSnackbar({
//                         open: true,
//                         message: res.data.message || "Unable to download",
//                         severity: 'error'
//                     });
//                 }
//             })
//             .catch((error) => {
//                 setSnackbar({
//                     open: true,
//                     message: error.response?.data?.description || "Server error, please try again later",
//                     severity: 'error'
//                 });
//             });
//     };

//     return (
//         <>
//             <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
//                 <DataGridPro
//                     rows={recordForTable}
//                     columns={columns(handleStatusChange, recordStatuses)}
//                     getRowId={(row) => row.ID}
//                     loading={loaderForTable}
//                     errorLogId={errorLogId}
//                     disableRowSelectionOnClick
//                     onRowSelectionModelChange={() => { }}
//                     sx={{
//                         maxHeight: '65vh',
//                         '& .MuiDataGrid-columnHeaders': {
//                             color: '#fff',
//                             fontWeight: 'bold',
//                             cursor: 'pointer',
//                             textAlign: 'right',
//                             zIndex: 1000,
//                         },
//                         '& .MuiDataGrid-columnHeader': {
//                             position: 'relative',
//                             textAlign: 'right',
//                             width: '100%',
//                             fontWeight: 'bold',
//                             backgroundColor: '#607d8b',
//                         },
//                         '& .MuiDataGrid-columnHeaderTitle': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-sortIcon': {
//                             opacity: 'inherit !important',
//                         },
//                         '& .MuiDataGrid-iconButtonContainer': {
//                             visibility: 'visible',
//                         },
//                         '& .MuiDataGrid-menuIconButton': {
//                             opacity: '1 !important',
//                             visibility: 'visible !important',
//                             display: 'flex !important',
//                         },
//                         '& .MuiDataGrid-columnHeaderIcon': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-row:nth-of-type(odd)': {
//                             backgroundColor: '#f9f9f9',
//                         },
//                         '& .MuiDataGrid-row:nth-of-type(even)': {
//                             backgroundColor: '#ffffff',
//                         },
//                         '& .MuiDataGrid-cell': {
//                             padding: '8px',
//                             textAlign: 'center',
//                         },
//                         '& .MuiDataGrid-footerContainer': {
//                             backgroundColor: '#f0f0f0',
//                         },
//                         '& .MuiCheckbox-root': {
//                             color: '#1976d2',
//                         },
//                         '& .MuiDataGrid-row:hover': {
//                             backgroundColor: '#d3e3fc',
//                             cursor: 'pointer',
//                         },
//                     }}
//                     components={{
//                         Toolbar: () => (
//                             <CustomToolbar
//                                 activeTab={activeTab}
//                                 onSubmit={handleSubmit}
//                                 onSave={handleSave}
//                                 onReset={handleReset}
//                                 isSubmitDisabled={areButtonsDisabled} // Updated to use areButtonsDisabled
//                                 isSaveDisabled={areButtonsDisabled} // New prop for Save button
//                                 errorLogId={errorLogId}
//                                 onError={handleErrorReport}
//                             />
//                         ),
//                         NoRowsOverlay: CustomNoRowsOverlay,
//                     }}
//                 />
//             </Box>
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={handleCloseSnackbar}
//                 anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//             >
//                 <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// };



// const IMSReport = ({ recordForTable, loaderForTable, getApiImsReport, activeTab }) => {
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: '',
//         severity: 'info',
//     });

//     const statusMap = {
//         A: 'Accepted',
//         P: 'Pending',
//         R: 'Rejected',
//     };

//     const reverseStatusMap = {
//         Accepted: 'A',
//         Pending: 'P',
//         Rejected: 'R',
//     };

//     const [recordStatuses, setRecordStatuses] = useState(
//         recordForTable.reduce((acc, row) => {
//             acc[row.ID] = statusMap[row.action] || '';
//             return acc;
//         }, {})
//     );

//     // State to track if records have been saved
//     const [isSaved, setIsSaved] = useState(false);

//     useEffect(() => {
//         setRecordStatuses((prev) =>
//             recordForTable.reduce((acc, row) => {
//                 acc[row.ID] = prev[row.ID] || statusMap[row.action] || '';
//                 return acc;
//             }, {})
//         );
//         // Reset isSaved when recordForTable changes, as new data means changes need to be saved again
//         setIsSaved(false);
//     }, [recordForTable]);

//     const handleCloseSnackbar = () => {
//         setSnackbar({ ...snackbar, open: false });
//     };

//     const handleStatusChange = (id, newStatus) => {
//         console.log('handleStatusChange - ID:', id, 'New Status:', newStatus);
//         setRecordStatuses((prev) => ({
//             ...prev,
//             [id]: newStatus,
//         }));
//         // Reset isSaved when status changes, as new changes need to be saved
//         setIsSaved(false);
//     };

//     const handleSubmit = async () => {
//         const business_entity_id = localStorage.getItem("business_entity_id");
//         const payload = {
//             business_entity_id: business_entity_id,
//             records: recordForTable.map((row) => ({
//                 record_type: row.record_type,
//                 ID: row.ID,
//                 stin: row.stin,
//                 inum: row.inum,
//                 inv_typ: row.inv_typ,
//                 action: reverseStatusMap[recordStatuses[row.ID]] || 'P',
//                 srcform: row.srcform || 'R1',
//                 rtnprd: row.rtnprd,
//                 idt: row.idt,
//                 val: row.val,
//                 pos: row.pos || '29',
//                 txval: row.txval || row.val,
//                 iamt: row.iamt || 0,
//                 camt: row.camt || 0,
//                 samt: row.samt || 0,
//                 cess: row.cess || 0,
//             })),
//         };

//         try {
//             const res = await axios.post('/push_to_ims_portal', payload);
//             console.log('IMS Accepted Report Response:', res.data);
//             setSnackbar({
//                 open: true,
//                 message: 'Records submitted successfully',
//                 severity: 'success',
//             });
//             setIsSaved(false); // Reset isSaved after successful submission
//             if (getApiImsReport) {
//                 await getApiImsReport();
//             }
//         } catch (error) {
//             console.error('Error submitting IMS records:', error);
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || 'Error submitting IMS records',
//                 severity: 'error',
//             });
//         }
//     };

//     const handleSave = async () => {
//         console.log('handleSave called with recordStatuses:', recordStatuses);
//         console.log('recordForTable:', recordForTable);
//         const business_entity_id = localStorage.getItem("business_entity_id");

//         if (!recordForTable || recordForTable.length === 0) {
//             console.log('recordForTable is empty or undefined');
//             setSnackbar({
//                 open: true,
//                 message: 'No records available to save',
//                 severity: 'error',
//             });
//             return;
//         }

//         // Filter records where the status has changed
//         const changedRecords = recordForTable
//             .filter((row) => recordStatuses[row.ID] && recordStatuses[row.ID] !== statusMap[row.action])
//             .map((row) => ({
//                 record_type: row.record_type,
//                 ID: row.ID,
//                 stin: row.stin,
//                 inum: row.inum,
//                 inv_typ: row.inv_typ,
//                 action: reverseStatusMap[recordStatuses[row.ID]] || 'P',
//                 srcform: row.srcform || 'R1',
//                 rtnprd: row.rtnprd,
//                 idt: row.idt,
//                 val: row.val,
//                 pos: row.pos || '29',
//                 txval: row.txval || row.val,
//                 iamt: row.iamt || 0,
//                 camt: row.camt || 0,
//                 samt: row.samt || 0,
//                 cess: row.cess || 0,
//             }));

//         if (changedRecords.length === 0) {
//             setSnackbar({
//                 open: true,
//                 message: 'No changes to save',
//                 severity: 'info',
//             });
//             return;
//         }

//         const payload = {
//             business_entity_id: business_entity_id,
//             records: changedRecords,
//         };

//         try {
//             const res = await axios.post('/save_ims_status', payload);
//             console.log('IMS Save Response:', res.data);
//             setSnackbar({
//                 open: true,
//                 message: 'Records saved successfully',
//                 severity: 'success',
//             });
//             setIsSaved(true); // Set isSaved to true on successful save
//             if (getApiImsReport) {
//                 await getApiImsReport();
//             }
//         } catch (error) {
//             console.error('Error saving IMS records:', error);
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || 'Error saving IMS records',
//                 severity: 'error',
//             });
//         }
//     };

//     return (
//         <>
//             <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
//                 <DataGridPro
//                     rows={recordForTable}
//                     columns={columns(handleStatusChange, recordStatuses)}
//                     getRowId={(row) => row.ID}
//                     loading={loaderForTable}
//                     disableRowSelectionOnClick
//                     onRowSelectionModelChange={() => {}}
//                     sx={{
//                         maxHeight: '65vh',
//                         '& .MuiDataGrid-columnHeaders': {
//                             color: '#fff',
//                             fontWeight: 'bold',
//                             cursor: 'pointer',
//                             textAlign: 'right',
//                             zIndex: 1000,
//                         },
//                         '& .MuiDataGrid-columnHeader': {
//                             position: 'relative',
//                             textAlign: 'right',
//                             width: '100%',
//                             fontWeight: 'bold',
//                             backgroundColor: '#607d8b',
//                         },
//                         '& .MuiDataGrid-columnHeaderTitle': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-sortIcon': {
//                             opacity: 'inherit !important',
//                         },
//                         '& .MuiDataGrid-iconButtonContainer': {
//                             visibility: 'visible',
//                         },
//                         '& .MuiDataGrid-menuIconButton': {
//                             opacity: '1 !important',
//                             visibility: 'visible !important',
//                             display: 'flex !important',
//                         },
//                         '& .MuiDataGrid-columnHeaderIcon': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-row:nth-of-type(odd)': {
//                             backgroundColor: '#f9f9f9',
//                         },
//                         '& .MuiDataGrid-row:nth-of-type(even)': {
//                             backgroundColor: '#ffffff',
//                         },
//                         '& .MuiDataGrid-cell': {
//                             padding: '8px',
//                             textAlign: 'center',
//                         },
//                         '& .MuiDataGrid-footerContainer': {
//                             backgroundColor: '#f0f0f0',
//                         },
//                         '& .MuiCheckbox-root': {
//                             color: '#1976d2',
//                         },
//                         '& .MuiDataGrid-row:hover': {
//                             backgroundColor: '#d3e3fc',
//                             cursor: 'pointer',
//                         },
//                     }}
//                     components={{
//                         Toolbar: () => (
//                             <CustomToolbar
//                                 activeTab={activeTab}
//                                 onSubmit={handleSubmit}
//                                 onSave={handleSave}
//                                 isSubmitDisabled={!isSaved} // Pass isSubmitDisabled prop
//                             />
//                         ),
//                         NoRowsOverlay: CustomNoRowsOverlay,
//                     }}
//                 />
//             </Box>
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={handleCloseSnackbar}
//                 anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//             >
//                 <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// };



// const IMSReport = ({ recordForTable, loaderForTable, getApiImsReport, activeTab }) => {
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: '',
//         severity: 'info',
//     });

//     // State to track dropdown selections (stores human-readable values: Accepted, Pending, Rejected, or '')
//     const [recordStatuses, setRecordStatuses] = useState(
//         recordForTable.reduce((acc, row) => {
//             // Use the action value directly from the API response
//             acc[row.ID] = row.action || ''; // Default to empty string if no action
//             return acc;
//         }, {})
//     );

//     // Sync recordStatuses when recordForTable changes
//     useEffect(() => {
//         setRecordStatuses((prev) =>
//             recordForTable.reduce((acc, row) => {
//                 // Preserve the API's action value or use the previous status if it exists
//                 acc[row.ID] = prev[row.ID] || row.action || '';
//                 return acc;
//             }, {})
//         );
//     }, [recordForTable]);

//     const handleCloseSnackbar = () => {
//         setSnackbar({ ...snackbar, open: false });
//     };

//     // Handler for status change
//     const handleStatusChange = (id, newStatus) => {
//         console.log('handleStatusChange - ID:', id, 'New Status:', newStatus);
//         setRecordStatuses((prev) => ({
//             ...prev,
//             [id]: newStatus,
//         }));
//     };

//     // Handler for submit button
//     const handleSubmit = async () => {
//         const business_entity_id = localStorage.getItem("business_entity_id");
//         const payload = {
//             business_entity_id: business_entity_id,
//             records: recordForTable.map((row) => ({
//                 record_type: row.record_type,
//                 ID: row.ID,
//                 stin: row.stin,
//                 inum: row.inum,
//                 inv_typ: row.inv_typ,
//                 action: recordStatuses[row.ID] || 'P', // Default to P if no status selected
//                 srcform: row.srcform || 'R1',
//                 rtnprd: row.rtnprd,
//                 idt: row.idt,
//                 val: row.val,
//                 pos: row.pos || '29',
//                 txval: row.txval || row.val,
//                 iamt: row.iamt || 0,
//                 camt: row.camt || 0,
//                 samt: row.samt || 0,
//                 cess: row.cess || 0,
//             })),
//         };

//         try {
//             const res = await axios.post('/push_to_ims_portal', payload);
//             console.log('IMS Accepted Report Response:', res.data);
//             setSnackbar({
//                 open: true,
//                 message: 'Records submitted successfully',
//                 severity: 'success',
//             });
//             if (getApiImsReport) {
//                 await getApiImsReport();
//             }
//         } catch (error) {
//             console.error('Error submitting IMS records:', error);
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || 'Error submitting IMS records',
//                 severity: 'error',
//             });
//         }
//     };

//     const handleSave = async () => {
//         const payload = {
//             ID: "84620",
//             status: "Accepted",
//             prev_action: "No action"
//         };

//         try {
//             const res = await axios.post('/push_manual_data_to_db', payload);
//             console.log('IMS Accepted Report Response:', res.data);
//             setSnackbar({
//                 open: true,
//                 message: 'Records submitted successfully',
//                 severity: 'success',
//             });
//             if (getApiImsReport) {
//                 await getApiImsReport();
//             }
//         } catch (error) {
//             console.error('Error submitting IMS records:', error);
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || 'Error submitting IMS records',
//                 severity: 'error',
//             });
//         }
//     }


//     return (
//         <>
//             <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
//                 <DataGridPro
//                     rows={recordForTable}
//                     columns={columns(handleStatusChange, recordStatuses)}
//                     getRowId={(row) => row.ID}
//                     loading={loaderForTable}
//                     disableRowSelectionOnClick
//                     onRowSelectionModelChange={() => { }}
//                     sx={{
//                         maxHeight: '65vh',
//                         '& .MuiDataGrid-columnHeaders': {
//                             color: '#fff',
//                             fontWeight: 'bold',
//                             cursor: 'pointer',
//                             textAlign: 'right',
//                             zIndex: 1000,
//                         },
//                         '& .MuiDataGrid-columnHeader': {
//                             position: 'relative',
//                             textAlign: 'right',
//                             width: '100%',
//                             fontWeight: 'bold',
//                             backgroundColor: '#607d8b',
//                         },
//                         '& .MuiDataGrid-columnHeaderTitle': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-sortIcon': {
//                             opacity: 'inherit !important',
//                         },
//                         '& .MuiDataGrid-iconButtonContainer': {
//                             visibility: 'visible',
//                         },
//                         '& .MuiDataGrid-menuIconButton': {
//                             opacity: '1 !important',
//                             visibility: 'visible !important',
//                             display: 'flex !important',
//                         },
//                         '& .MuiDataGrid-columnHeaderIcon': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
//                             color: '#fff',
//                         },
//                         '& .MuiDataGrid-row:nth-of-type(odd)': {
//                             backgroundColor: '#f9f9f9',
//                         },
//                         '& .MuiDataGrid-row:nth-of-type(even)': {
//                             backgroundColor: '#ffffff',
//                         },
//                         '& .MuiDataGrid-cell': {
//                             padding: '8px',
//                             textAlign: 'center',
//                         },
//                         '& .MuiDataGrid-footerContainer': {
//                             backgroundColor: '#f0f0f0',
//                         },
//                         '& .MuiCheckbox-root': {
//                             color: '#1976d2',
//                         },
//                         '& .MuiDataGrid-row:hover': {
//                             backgroundColor: '#d3e3fc',
//                             cursor: 'pointer',
//                         },
//                     }}
//                     components={{
//                         Toolbar: () => <CustomToolbar activeTab={activeTab} onSubmit={handleSubmit} onSave={handleSave} />,
//                         NoRowsOverlay: CustomNoRowsOverlay,
//                     }}
//                 />
//             </Box>
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={handleCloseSnackbar}
//                 anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//             >
//                 <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// };


const IMSAccepted = ({ recordForAcceptedTable, loaderForTable, getApiImsAccepted, pagination, handlePageChange, handleRowsPerPageChange, ims_recon_id, activeTab }) => {
    // State to hold filtered data and search term
    const [filteredRecords, setFilteredRecords] = useState(recordForAcceptedTable);
    const [pageSize, setPageSize] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };


    // Update filteredRecords when recordForAcceptedTable changes
    useEffect(() => {
        setFilteredRecords(recordForAcceptedTable);
    }, [recordForAcceptedTable]);

    // Search handler
    const handleSearchEvent = (e) => {
        const term = e.target.value.trim().toLowerCase();
        setSearchTerm(term);

        if (!term) {
            setFilteredRecords(recordForAcceptedTable);
            return;
        }

        const filtered = recordForAcceptedTable.filter((v) => {
            return (
                String(v.GSTIN_of_Supplier || "").toLowerCase().includes(term) ||
                String(v.Trade_Legal_name || "").toLowerCase().includes(term) ||
                String(v.Invoice_Number_Credit_Note_Number_Debit_Note_Number || "").toLowerCase().includes(term) ||
                String(v.Invoice_Type_Debit_Note_Supply_Type_Credit_Note_Supply_Type || "").toLowerCase().includes(term) ||
                String(v.Invoice_Date_Credit_Note_Date_Debit_Note_Date || "").toLowerCase().includes(term) ||
                String(v.Source_Return_Period || "").toLowerCase().includes(term) ||
                String(v.Source_Filing_Status || "").toLowerCase().includes(term) ||
                String(v.Status || "").toLowerCase().includes(term) ||
                String(v.GSTR_2B_Recon_Remarks || "").toLowerCase().includes(term) ||
                String(v.GSTR_2B_Recon_Remarks_2 || "").toLowerCase().includes(term)
            );
        });

        setFilteredRecords(filtered);
    };

    // Handle refresh button
    const handleRefresh = () => {
        if (!ims_recon_id) {
            console.error("ims_recon_id is required for refreshing data");
            return;
        }
        getApiImsAccepted(ims_recon_id, 0, pagination.rowsPerPage, searchTerm);
    };

    return (
        <>
            <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
                <DataGridPro
                    rows={recordForAcceptedTable}
                    columns={acceptColumns}
                    getRowId={(row) => row.ID}
                    loading={loaderForTable}
                    pagination
                    pageSize={pageSize}
                    pageSizeOptions={[5, 10, 25, 50]}
                    onPageSizeChange={handlePageSizeChange}
                    onPageChange={handlePageChange}
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={() => { }}
                    // localeText={{
                    //     toolbarDensity: 'Size',
                    //     toolbarDensityLabel: 'Size',
                    //     toolbarDensityCompact: 'Small',
                    //     toolbarDensityStandard: 'Medium',
                    //     toolbarDensityComfortable: 'Large',
                    //     footerRowSelected: () => '',
                    // }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            backgroundColor: '#607d8b',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-sortIcon': {
                            opacity: 'inherit !important',
                        },
                        '& .MuiDataGrid-iconButtonContainer': {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer',
                        },
                    }}
                    components={{
                        Toolbar: CustomToolbar,
                        NoRowsOverlay: CustomNoRowsOverlay,
                    }}
                />
            </Box>
        </>
    );
};



const IMSRejected = ({ recordForRejectedTable, loaderForTable, getApiImsRejected, handleStatus, pagination, handlePageChange, handleRowsPerPageChange, activeTab }) => {
    // State to hold filtered data and search term
    const [filteredRecords, setFilteredRecords] = useState(recordForRejectedTable);
    const [pageSize, setPageSize] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };


    // Update filteredRecords when recordForRejectedTable changes
    useEffect(() => {
        setFilteredRecords(recordForRejectedTable);
    }, [recordForRejectedTable]);

    // Search handler
    const handleSearchEvent = (e) => {
        const term = e.target.value.trim().toLowerCase();
        setSearchTerm(term);

        if (!term) {
            // If search term is empty, reset to original records
            setFilteredRecords(recordForRejectedTable);
            return;
        }

        const filtered = recordForRejectedTable.filter((v) => {
            return (
                String(v.GSTIN_of_Supplier || "").toLowerCase().includes(term) ||
                String(v.Trade_Legal_name || "").toLowerCase().includes(term) ||
                String(v.Invoice_Number_Credit_Note_Number_Debit_Note_Number || "").toLowerCase().includes(term) ||
                String(v.Invoice_Type_Debit_Note_Supply_Type_Credit_Note_Supply_Type || "").toLowerCase().includes(term) ||
                String(v.Invoice_Date_Credit_Note_Date_Debit_Note_Date || "").toLowerCase().includes(term) ||
                String(v.Source_Return_Period || "").toLowerCase().includes(term) ||
                String(v.Source_Filing_Status || "").toLowerCase().includes(term) ||
                String(v.Status || "").toLowerCase().includes(term) ||
                String(v.GSTR_2B_Recon_Remarks || "").toLowerCase().includes(term) ||
                String(v.GSTR_2B_Recon_Remarks_2 || "").toLowerCase().includes(term)
            );
        });

        setFilteredRecords(filtered);
    };

    return (
        <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
            <DataGridPro
                rows={recordForRejectedTable}
                columns={rejectColumns}
                getRowId={(row) => row.ID}
                loading={loaderForTable}
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePageChange}
                disableRowSelectionOnClick
                onRowSelectionModelChange={() => { }}
                // localeText={{
                //     toolbarDensity: 'Size',
                //     toolbarDensityLabel: 'Size',
                //     toolbarDensityCompact: 'Small',
                //     toolbarDensityStandard: 'Medium',
                //     toolbarDensityComfortable: 'Large',
                //     footerRowSelected: () => '',
                // }}
                sx={{
                    maxHeight: '65vh',
                    '& .MuiDataGrid-columnHeaders': {
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        backgroundColor: '#607d8b',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-sortIcon': {
                        opacity: 'inherit !important',
                    },
                    '& .MuiDataGrid-iconButtonContainer': {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer',
                    },
                }}
                components={{
                    Toolbar: () => <CustomToolbar activeTab={activeTab} />,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
            />
        </Box>
    );
};

const IMSPending = ({ recordForPendingTable, loaderForTable, handleStatus, reconId, getApiImsPending, pagination, handlePageChange, handleRowsPerPageChange, activeTab }) => {
    // State to hold filtered data and search term
    const [filteredRecords, setFilteredRecords] = useState(recordForPendingTable);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);


    // Update filteredRecords when recordForPendingTable changes
    useEffect(() => {
        setFilteredRecords(recordForPendingTable);
    }, [recordForPendingTable]);

    // Search handler
    const handleSearchEvent = (e) => {
        const term = e.target.value.trim().toLowerCase();
        setSearchTerm(term);

        if (!term) {
            // If search term is empty, reset to original records
            setFilteredRecords(recordForPendingTable);
            return;
        }

        const filtered = recordForPendingTable.filter((v) => {
            return (
                String(v.GSTIN_of_Supplier || "").toLowerCase().includes(term) ||
                String(v.Trade_Legal_name || "").toLowerCase().includes(term) ||
                String(v.Invoice_Number_Credit_Note_Number_Debit_Note_Number || "").toLowerCase().includes(term) ||
                String(v.Invoice_Type_Debit_Note_Supply_Type_Credit_Note_Supply_Type || "").toLowerCase().includes(term) ||
                String(v.Invoice_Date_Credit_Note_Date_Debit_Note_Date || "").toLowerCase().includes(term) ||
                String(v.Source_Return_Period || "").toLowerCase().includes(term) ||
                String(v.Source_Filing_Status || "").toLowerCase().includes(term) ||
                String(v.Status || "").toLowerCase().includes(term) ||
                String(v.GSTR_2B_Recon_Remarks || "").toLowerCase().includes(term) ||
                String(v.GSTR_2B_Recon_Remarks_2 || "").toLowerCase().includes(term)
            );
        });

        setFilteredRecords(filtered);
    };


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    return (
        <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
            <DataGridPro
                rows={recordForPendingTable}
                columns={pendingColumns}
                getRowId={(row) => row.ID}
                loading={loaderForTable}
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePageChange}
                disableRowSelectionOnClick
                onRowSelectionModelChange={() => { }}
                // localeText={{
                //     toolbarDensity: 'Size',
                //     toolbarDensityLabel: 'Size',
                //     toolbarDensityCompact: 'Small',
                //     toolbarDensityStandard: 'Medium',
                //     toolbarDensityComfortable: 'Large',
                //     footerRowSelected: () => '',
                // }}
                sx={{
                    maxHeight: '65vh',
                    '& .MuiDataGrid-columnHeaders': {
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        backgroundColor: '#607d8b',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-sortIcon': {
                        opacity: 'inherit !important',
                    },
                    '& .MuiDataGrid-iconButtonContainer': {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer',
                    },
                }}
                components={{
                    Toolbar: () => <CustomToolbar activeTab={activeTab} />,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
            />
        </Box>
    );
};

const IMSNoAction = ({ recordForNoActionTable, loaderForTable, getApiImsNoAction, handleStatus, reconId, pagination, handlePageChange, handleRowsPerPageChange, activeTab }) => {
    // State to hold filtered data and search term
    const [filteredRecords, setFilteredRecords] = useState(recordForNoActionTable);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [errorLogId, setErrorLogId] = useState(null);

    // Update filteredRecords when recordForNoActionTable changes
    useEffect(() => {
        setFilteredRecords(recordForNoActionTable);
    }, [recordForNoActionTable]);



    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    // Search handler
    const handleSearchEvent = (e) => {
        const term = e.target.value.trim().toLowerCase();
        setSearchTerm(term);

        if (!term) {
            // If search term is empty, reset to original records
            setFilteredRecords(recordForNoActionTable);
            return;
        }

        const filtered = recordForNoActionTable.filter((v) => {
            return (
                String(v.GSTIN_of_Supplier || "").toLowerCase().includes(term) ||
                String(v.Trade_Legal_name || "").toLowerCase().includes(term) ||
                String(v.Invoice_Number_Credit_Note_Number_Debit_Note_Number || "").toLowerCase().includes(term) ||
                String(v.Invoice_Type_Debit_Note_Supply_Type_Credit_Note_Supply_Type || "").toLowerCase().includes(term) ||
                String(v.Invoice_Date_Credit_Note_Date_Debit_Note_Date || "").toLowerCase().includes(term) ||
                String(v.Source_Return_Period || "").toLowerCase().includes(term) ||
                String(v.Source_Filing_Status || "").toLowerCase().includes(term) ||
                String(v.Status || "").toLowerCase().includes(term) ||
                String(v.GSTR_2B_Recon_Remarks || "").toLowerCase().includes(term) ||
                String(v.GSTR_2B_Recon_Remarks_2 || "").toLowerCase().includes(term)
            );
        });

        setFilteredRecords(filtered);
    };

    return (
        <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
            <DataGridPro
                rows={recordForNoActionTable}
                columns={noactionColumns}
                getRowId={(row) => row.ID}
                loading={loaderForTable}
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePageChange}
                disableRowSelectionOnClick
                onRowSelectionModelChange={() => { }}
                // localeText={{
                //     toolbarDensity: 'Size',
                //     toolbarDensityLabel: 'Size',
                //     toolbarDensityCompact: 'Small',
                //     toolbarDensityStandard: 'Medium',
                //     toolbarDensityComfortable: 'Large',
                //     footerRowSelected: () => '',
                // }}
                sx={{
                    maxHeight: '65vh',
                    '& .MuiDataGrid-columnHeaders': {
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        backgroundColor: '#607d8b',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-sortIcon': {
                        opacity: 'inherit !important',
                    },
                    '& .MuiDataGrid-iconButtonContainer': {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer',
                    },
                }}
                components={{
                    Toolbar: () => <CustomToolbar activeTab={activeTab} />,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
            />
        </Box>
    );
};

// Chart Component
const IMSChart = ({ chartData }) => {
    const chartContainerRef = useRef(null);

    const customColors = [
        '#1f77b4', // Blue
        '#ff7f0e', // Orange
        '#2ca02c', // Green
        '#d62728', // Red
        '#9467bd', // Purple
        '#8c564b', // Brown
        '#e377c2', // Pink
        '#7f7f7f', // Gray
        '#bcbd22', // Olive
        '#17becf', // Cyan
    ];

    useEffect(() => {
        if (chartData && chartContainerRef.current && chartData.categories && chartData.series) {
            Highcharts.chart(chartContainerRef.current, {
                chart: {
                    type: 'column',
                    options3d: {
                        enabled: true,
                        alpha: 15, // Tilt angle
                        beta: 15, // Rotation angle
                        depth: 50, // Depth of the 3D chart
                        viewDistance: 25, // Distance of the viewer
                    },
                },
                title: {
                    text: 'IMS Reconciliation Breakdown',
                    style: {
                        fontSize: '16px',
                        fontWeight: 'bold',
                    },
                },
                xAxis: {
                    categories: chartData.categories,
                    crosshair: true,
                    title: {
            text: "IMS Recon Remarks",
                    },
                    labels: {
                        style: {
                            fontSize: '12px',
                        },
                    },
                },
                yAxis: [
                    {
                        min: 0,
                        title: {
                            text: 'Count of Invoice Number',
                            style: {
                                fontSize: '12px',
                            },
                        },
                        labels: {
                            style: {
                                fontSize: '10px',
                            },
                        },
                    },
                    {
                        min: 0,
                        title: {
                            text: 'Tax Amount (₹)',
                            style: {
                                fontSize: '12px',
                            },
                        },
                        labels: {
                            style: {
                                fontSize: '10px',
                            },
                            formatter: function () {
                                return this.value.toLocaleString('en-IN');
                            },
                        },
                        opposite: true,
                    },
                ],
                tooltip: {
                    shared: false,
                    formatter: function () {
                        const value = this.series.userOptions.metricName.includes('Count')
                            ? this.y
                            : '₹' + this.y.toLocaleString('en-IN');
                        return `<b>${this.x}</b><br/>
                    <span style="color:${this.series.color}">\u25CF</span> ${this.series.name}: ${value}`;
                    },
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.05,
                        groupPadding: 0.1,
                        depth: 25, // Depth of individual columns
                        shadow: {
                            enabled: true,
                            color: 'rgba(0,0,0,0.3)',
                            offsetX: 2,
                            offsetY: 2,
                            opacity: 0.5,
                            width: 5,
                        },
                    },
                },
                legend: {
                    enabled: false,
                },
                series: chartData.series.map((seriesItem, index) => ({
                    name: seriesItem.name,
                    data: seriesItem.data,
                    yAxis: seriesItem.yAxis,
                    color: customColors[index % customColors.length],
                    metricName: seriesItem.metricName,
                })),
                credits: {
                    enabled: false,
                },
                exporting: {
                    enabled: false,
                },
            });
        }
    }, [chartData]);

    return <div ref={chartContainerRef} style={{ height: '400px', width: '100%' }}></div>;
};
// New Expandable Table Component
const ExpandableTable = ({ availableMonths, selectedMonths, setSelectedMonths, reconId, getSummary, recordForExpandTable, loaderForTable,onClickExport }) => {
    const handleMonthChange = (event) => {
        const newSelectedMonths = event.target.value;
        console.log('Selected Months:', newSelectedMonths);
        setSelectedMonths(newSelectedMonths);
        if (reconId && newSelectedMonths.length > 0) {
            getSummary(reconId, newSelectedMonths);
        } else {
            console.warn('No reconId or no months selected');
        }
    };

    // Format number for Indian locale
    const formatNumber = (num) => {
        if (num === undefined || num === null) return '-';
        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    return (
        <div>
            <div style={{ marginBottom: '1rem' }}>
                <Box sx={{ minWidth: 200 }}>
                    <FormControl fullWidth>
                        <InputLabel
                            id="period-range-select-label"
                            shrink
                            sx={{
                                fontSize: '16px',
                                color: '#000',
                                // backgroundColor: '#fff', // Ensure background prevents overlap
                                padding: '0 4px',
                                transform: selectedMonths.length > 0 ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 10px) scale(1)', // Adjust transform for proper positioning
                                zIndex: 1, // Ensure label stays above the Select
                            }}
                        >
                            Period Range <span style={{ color: 'red' }}>*</span>
                        </InputLabel>
                        <Select
                            multiple
                            labelId="period-range-select-label"
                            id="period-range-select"
                            value={selectedMonths}
                            onChange={handleMonthChange}
                            disabled={!reconId}
                            label="Period Range"
                            sx={{
                                height: '40px',
                                width: '200px',
                                fontSize: '14px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#c4c4c4',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#000',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#1976d2',
                                    borderWidth: '2px',
                                },
                            }}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em style={{ color: '#757575' }}>Select months</em>;
                                }
                                return selected.join(', ');
                            }}
                        >
                            {availableMonths.length === 0 ? (
                                <MenuItem disabled>
                                    <em>No months available</em>
                                </MenuItem>
                            ) : (
                                availableMonths.map((month) => (
                                    <MenuItem key={month} value={month}>
                                        <Checkbox checked={selectedMonths.includes(month)} />
                                        <ListItemText primary={month} />
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                </Box>
            </div>
      <BoxWrapper
        boxTitle="IMS Reconciliation"
        enableAddButton={true}
        addButtonLabel="EXPORT"
        addButtonHandlerFn={onClickExport}
      >
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'row',
                            marginRight: '16px',
                            gap: '16px',
                        }}
                    ></div>
                </div>
                <div>
                    <table className="custome-table">
                        <thead>
                            <tr>
                <th>IMS Recon Remarks</th>
                                <th>Status</th>
                                <th>Count of Invoice number</th>
                                <th>Integrated Tax(₹)</th>
                                <th>Central Tax(₹)</th>
                                <th>State/UT Tax(₹)</th>
                                <th>Cess(₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recordForExpandTable.map((row, index) => (
                                <tr key={row.ID || `row-${index}`}>
                                    <td>{row.GSTR_2B_Recon_Remarks || '-'}</td>
                                    <td>{row.Status || '-'}</td>
                                    <td>{row.Count_of_Invoice_Number || '-'}</td>
                                    <td>₹{formatNumber(row.Integrated_Tax)}</td>
                                    <td>₹{formatNumber(row.Central_Tax)}</td>
                                    <td>₹{formatNumber(row.State_UT_Tax)}</td>
                                    <td>₹{formatNumber(row.Cess)}</td>
                                </tr>
                            ))}
                            {loaderForTable ? (
                                <tr>
                                    <td
                                        colSpan={7}
                                        style={{
                                            color: 'black',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        Loading…Please wait
                                    </td>
                                </tr>
                            ) : recordForExpandTable.length === 0 ? (
                                <tr>
                                    <td colSpan={7} style={{ color: 'red', textAlign: 'center' }}>
                                        No Data Found!
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>
            </BoxWrapper>
        </div>
    );
};


export default function IMSReconciliation() {
    const history = useHistory();
    const location = useLocation();
    const { ims_recon_id } = useParams();
    const [activeTab, setActiveTab] = useState("dashboard");
    const [recordForLogTable, setRecordForLogTable] = useState([]);
    const [recordForTable, setRecordForTable] = useState([]);
    const [recordForAcceptedTable, setRecordForAcceptedTable] = useState([]);
    const [recordForRejectedTable, setRecordForRejectedTable] = useState([]);
    const [recordForPendingTable, setRecordForPendingTable] = useState([]);
    const [recordForNoActionTable, setRecordForNoActionTable] = useState([]);
  const [isInitializing, setIsInitializing] = useState(true);
    const [loaderForTable, setLoaderForTable] = useState(false);
    const [chartData, setChartData] = useState(null);
    const [reconId, setReconId] = useState(null);
    const [taxPeriod, setTaxPeriod] = useState(null);
    const [showTabs, setShowTabs] = useState(false);
    const [showLogTable, setShowLogTables] = useState(true);
    const [businessEntityId, setBusinessEntityId] = useState(localStorage.getItem("business_entity_id"));
    const [selectedReconId, setSelectedReconId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [availableMonths, setAvailableMonths] = useState([]);
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [recordForExpandTable, setRecordForExpandTable] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [recordForImsReconTable, setRecordForImsReconTable] = useState([]);
    const iconColors = ['#3B82F6', '#EF4444', '#F59E0B', '#6B7280'];
    const [metrics, setMetrics] = useState({
        accepted: { count: 0, total: 0 },
        rejected: { count: 0, total: 0 },
        pending: { count: 0, total: 0 },
        noAction: { count: 0, total: 0 },
    });
    const [errorLogId, setErrorLogId] = useState(null);
    const [username, setUserName] = useState("");
    const [openOTPModal, setOpenOTPModal] = useState(false);
    const [openEstablisConnectionDrawer, setOpenEstablisConnectionDrawer] =
        useState(false);
    const [authAPiResData, setAuthApiResData] = useState({});
    const [auth_otp, setAuthOTP] = useState("");
    const [authToken, setAuthToken] = useState("");
    const [otpApiData, setOtpApidata] = useState({});
    const [vyanaList, setVyanaList] = useState([]);
  const [showPushPopup, setShowPushPopup] = useState(false);
  const [pushStatus, setPushStatus] = useState(null); // { status, date_time }
  const [pushStatusLoading, setPushStatusLoading] = useState(false);


    const handleBack = () => {
        history.push('/reconCards');
    };

    const [pagination, setPagination] = useState({
        page: 0, // 0-based for TablePagination
        rowsPerPage: 10, // Set to 10 as requested
        total_count: 0,
        total_pages: 1,
    });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info'
    });
    const [establishConnectionButton, setEstablisConnectionButton] = useState(
        "button-outlined-secondary"
    );

    const [successMessage, setSuccessMessage] = useState("");
    const form = useRef("form");

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
        zIndex: 1300, // Increased z-index to ensure modal visibility
    };


    const formatNumber = (num) => {
        if (num === undefined || num === null) return '0';
        return num.toLocaleString('en-IN');
    };

    // Updated handlePageChange to match TablePagination signature
    const handlePageChange = (event, newPage) => {
        setPagination((prev) => ({ ...prev, page: newPage }));
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setPagination((prev) => ({
            ...prev,
            page: 0, // Reset to first page
            rowsPerPage: newRowsPerPage,
        }));
    };


    //   const vyanaAuthHandler = () => {
    //     let payload = {
    //       user_name: username,
    //       business_entity_id: localStorage.getItem("business_entity_id"),
    //       app_key: otpApiData.app_key,
    //       transaction_id: otpApiData.transaction_id,
    //       otp: auth_otp,
    //     };

    //     console.log("vyana/authenticate payload:", payload); // Debug payload

    //     axios
    //       .post("/vyana/authenticate", payload)
    //       .then((res) => {
    //         if (res.data.status === true) {
    //           setOpenOTPModal(false);
    //           setOpenEstablisConnectionDrawer(false);
    //           setEstablisConnectionButton("button-connection-established");
    //           setAuthApiResData({
    //             ...authAPiResData,
    //             sek: res.data.sek,
    //             auth_token: res.data.auth_token,
    //           });
    //           getApiVyanaList();
    //           setSnackbar({
    //             open: true,
    //             message: res.data.message,
    //             severity: 'success'
    //           });
    //           setUserName(""); // Reset username after successful authentication
    //           setTimeout(() => {
    //             setEstablisConnectionButton("button-outlined-secondary");
    //           }, 300000);
    //         } else {
    //           setSnackbar({
    //             open: true,
    //             message: res.data.error,
    //             severity: 'error'
    //           });
    //           setOpenOTPModal(true);
    //           setEstablisConnectionButton("button-outlined-secondary");
    //           setUserName(""); // Reset username after failed authentication
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error.response?.message || error.message);
    //         setOpenOTPModal(true);
    //         setEstablisConnectionButton("button-outlined-secondary");
    //         setUserName(""); // Reset username after error
    //         setSnackbar({
    //           open: true,
    //           message: error.response?.message || error.message,
    //           severity: 'error'
    //         });
    //       });
    //   };

    const closeEstablisConnectionDrawerHamdler = () => {
        setOpenEstablisConnectionDrawer(false);
        // Removed setUserName("") to preserve username
    };

    const closeOptModalHandler = () => {
        setAuthOTP("");
        setOpenOTPModal(false);
    };

    const vyanaAuthHandler = () => {
        let payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
            app_key: otpApiData.app_key,
            transaction_id: otpApiData.transaction_id,
            otp: auth_otp,
        };

        console.log("vyana/authenticate payload:", payload); // Debug payload

        axios
            .post("/vyana/authenticate", payload)
            .then((res) => {
                if (res.data.status === true) {
                    setOpenOTPModal(false);
                    setOpenEstablisConnectionDrawer(false);
                    setEstablisConnectionButton("button-connection-established");
                    setAuthApiResData({
                        ...authAPiResData,
                        sek: res.data.sek,
                        auth_token: res.data.auth_token,
                    });
                    getApiVyanaList();
                    setSnackbar({
                        open: true,
                        message: res.data.message,
                        severity: 'success'
                    });
                    setUserName(""); // Reset username after successful authentication
                    setTimeout(() => {
                        setEstablisConnectionButton("button-outlined-secondary");
                    }, 300000);
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.error,
                        severity: 'error'
                    });
                    setOpenOTPModal(true);
                    setEstablisConnectionButton("button-outlined-secondary");
                    setUserName(""); // Reset username after failed authentication
                }
            })
            .catch((error) => {
                console.log(error.response?.message || error.message);
                setOpenOTPModal(true);
                setEstablisConnectionButton("button-outlined-secondary");
                setUserName(""); // Reset username after error
                setSnackbar({
                    open: true,
                    message: error.response?.message || error.message,
                    severity: 'error'
                });
            });
    };

    const getApiVyanaList = () => {
        axios
            .get(`/vyana/get_list/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                if (res.data.status === true) {
                    setVyanaList(res.data.data);
                } else {
                }
            })
            .catch((error) => {
            });
    };

    const getOtpForAuthHandler = () => {
        let payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
        };

        console.log("vyana/send_otp payload:", payload); // Debug payload

        axios
            .post("/vyana/send_otp", payload)
            .then((res) => {
                console.log("API Response:", res.data);
                if (res.data.status === true) {
                    if (res.data.is_authenticated === true && res.data.is_otp_sent === false) {
                        console.log("Case 1: is_authenticated true, is_otp_sent false");
                        setOpenOTPModal(false);
                        if (res.data.message === "Connection established.") {
                            setSuccessMessage(res.data.message);
                            setAuthToken(res.data.auth_token);
                        }
                        setSnackbar({
                            open: true,
                            message: res.data.message,
                            severity: 'success'
                        });
                        closeEstablisConnectionDrawerHamdler();
                    } else if (res.data.is_authenticated === false && res.data.is_otp_sent === true) {
                        console.log("Case 2: Setting openOTPModal to true");
                        closeEstablisConnectionDrawerHamdler();
                        console.log("setting otp model Open:");
                        setOpenOTPModal(true);
                        setSnackbar({
                            open: true,
                            message: res.data.message,
                            severity: 'success'
                        });
                    } else {
                        console.log("Case 3: Else block, setting openOTPModal and otpApiData");
                        setOpenOTPModal(true);
                        setOtpApidata({
                            ...otpApiData,
                            transaction_id: res.data.transaction_id,
                            app_key: res.data.app_key,
                        });
                    }
                } else {
                    console.log("API status false, error:", res.data.error);
                    setSnackbar({
                        open: true,
                        message: res.data.error,
                        severity: 'error'
                    });
                    setOpenOTPModal(false);
                    setEstablisConnectionButton("button-outlined-secondary");
                }
            })
            .catch((error) => {
                console.error("API Error:", error.response?.message || error.message);
                setSnackbar({
                    open: true,
                    message: error.response?.message || error.message,
                    severity: 'error'
                });
            });
    };






    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

  // useEffect(() => {
  //     if (ims_recon_id) {
  //         console.log('Initializing with ims_recon_id from URL:', ims_recon_id);
  //         setReconId(ims_recon_id);
  //         // setTaxPeriod(tax_period);
  //         setShowTabs(true);
  //         setShowLogTables(false);
  //         setPagination((prev) => ({ ...prev, page: 0 }));
  //         setLoaderForTable(true);
  //         getApiList(ims_recon_id);
  //     } else {
  //         console.log('No ims_recon_id in URL, showing LogTable');
  //         setShowTabs(false);
  //         setShowLogTables(true);
  //         setReconId(null);
  //         getApiLogReport();
  //     }
  // }, [ims_recon_id]);

    useEffect(() => {
    const initializeComponent = async () => {
      const business_entity_id = localStorage.getItem("business_entity_id");
      const org_gstin =
        localStorage.getItem("gstin") || localStorage.getItem("gst");

      if (!business_entity_id || !org_gstin) {
        setSnackbar({
          open: true,
          message: "Missing business entity or GSTIN information",
          severity: "error",
        });
        setLoaderForTable(false);
        setIsInitializing(false);
        return;
      }

      const payload = {
        business_entity_id: parseInt(business_entity_id),
        org_gstin: org_gstin,
        report_type: "ims",
      };
      setLoaderForTable(true);

      try {
        const latestRecordsResponse = await axios.post(
          "/get_latest_recon_records",
          payload,
        );
        let imsReconId = null;

        if (latestRecordsResponse.data.data?.ims_recon_id !== undefined) {
          imsReconId = latestRecordsResponse.data.data.ims_recon_id;
        } else if (latestRecordsResponse.data.ims_recon_id !== undefined) {
          imsReconId = latestRecordsResponse.data.ims_recon_id;
        }
        if (imsReconId !== null && imsReconId !== undefined) {
          localStorage.setItem("ims_recon_id", imsReconId);
          console.log(imsReconId);
          setReconId(imsReconId);
            setShowTabs(true);
            setShowLogTables(false);
          await getApiList(imsReconId);

          setSnackbar({
            open: true,
            message: "Latest IMS Reconciliation data loaded successfully!",
            severity: "success",
          });
        } else {
          setSnackbar({ open: true, message: "No existing record found. Initiating new reconciliation...", severity: "info" });
          await runImsReconWithSSE(org_gstin, business_entity_id);
          return;
        }
      } catch (error) {
        if (
          error.response?.status === 400 &&
          error.config?.url?.includes("get_latest_recon_records")
        ) {
          await runImsReconWithSSE(org_gstin, business_entity_id);
          return;
        }
        setSnackbar({
          open: true,
          message:
            error.response?.data?.message ||
            error.message ||
            "Error loading IMS reconciliation",
          severity: "error",
        });
      } finally {
        setLoaderForTable(false);
        setIsInitializing(false);
        }
    };

    initializeComponent();
  }, []);

    useEffect(() => {
    if (location.state?.returnTab === "imsReport") {
      setActiveTab("imsReport");
        }
    }, [location]);

  const handleresetApi = () => { };

    const handleViewData = (ims_recon_id, tax_period) => {
    const business_entity_id = localStorage.getItem("business_entity_id");
    const org_gstin =
      localStorage.getItem("gstin") || localStorage.getItem("gst");

    const payload = {
      report_type: "ims",
      org_gstin: org_gstin,
      business_entity_id: parseInt(business_entity_id),
    };

    setLoaderForTable(true);
    axios
      .post("/unified_auto_reconciliation", payload)
      .then((response) => {
        const res = response.data;

        if (
          res.status === true ||
          res.status === "true" ||
          res.status === "pass"
        ) {
          const reconId = res.ims_recon_id || res.recon_id || res.id;

          if (reconId) {
            localStorage.setItem("ims_recon_id", reconId);
            localStorage.setItem("tax_period", tax_period || "");

            setReconId(reconId);
            setTaxPeriod(tax_period);
            history.push(`/IMSReconciliation_data/${reconId}/${tax_period}`);
                setShowTabs(true);
                setShowLogTables(false);
                setPagination((prev) => ({ ...prev, page: 0 }));
            getApiList(reconId);

                setSnackbar({
                    open: true,
              message:
                res.message || "IMS Reconciliation completed successfully!",
              severity: "success",
            });
          } else {
            setSnackbar({
              open: true,
              message: "Reconciliation completed but no ID returned.",
              severity: "warning",
                });
            }
        } else {
            console.warn('Invalid parameters in handleViewData:', { ims_recon_id, tax_period });
            setSnackbar({
                open: true,
            message: res.message || "Failed to run reconciliation.",
            severity: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error running IMS reconciliation:", error);
        let errorMessage = "Failed to run reconciliation. Please try again.";

        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
      })
      .finally(() => {
        setLoaderForTable(false);
      });
  };

  const runImsReconWithSSE = async (org_gstin, business_entity_id) => {
    try {
      setLoaderForTable(true);
      setSnackbar({ open: true, message: "Opening SSE connection...", severity: "info" });

      const sseToken = generateUUID();

      await initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');
      setSnackbar({ open: true, message: "Reconciliation started. Waiting for result...", severity: "info" });

      const reconPayload = {
        report_type: "ims",
        org_gstin: org_gstin,
        business_entity_id: parseInt(business_entity_id),
        sse_token: sseToken,
        functionality: 'IMS Recon',
      };

      const reconResponse = await axios.post("/unified_auto_reconciliation", reconPayload);
      console.log('Recon API response:', reconResponse.data);

      if (!reconResponse.data || reconResponse.data.status === false) {
        if (eventSourceRef.current) { eventSourceRef.current.close(); eventSourceRef.current = null; }
        setLoaderForTable(false);
        setIsInitializing(false);
        setSnackbar({ open: true, message: reconResponse.data?.message || "Failed to initiate reconciliation", severity: "error" });
        return;
      }

      setSnackbar({ open: true, message: "Reconciliation initiated. Waiting for result...", severity: "info" });
      // Result arrives via SSE → fetchAndUpdateImsData

    } catch (error) {
      if (eventSourceRef.current) { eventSourceRef.current.close(); eventSourceRef.current = null; }
      setLoaderForTable(false);
      setIsInitializing(false);
      setSnackbar({ open: true, message: error?.response?.data?.message || error.message || "Failed to initiate reconciliation", severity: "error" });
    }
  };

  const initiateReconSSE = (sseToken) => {
    return new Promise((resolve, reject) => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }

      console.log("SSE Starting point");
      sseOpenedRef.current = false;

      const sseUrl = `${SSE_BASE_URL}/api/sse/${sseToken}`;
      const es = new EventSource(sseUrl);
      eventSourceRef.current = es;

      es.onopen = () => {
        sseOpenedRef.current = true;
        console.log('SSE onopen fired, readyState:', es.readyState);
        resolve();
      };

      es.onmessage = (event) => {
        console.log("RAW SSE:", event.data);
        try {
          const data = JSON.parse(event.data);
          console.log("REAL SSE DATA:", data);
          if (data.status === "done" || data.status === "Pass") {
            if (eventSourceRef.current) {
              eventSourceRef.current.close();
              eventSourceRef.current = null;
            }
            const imsReconId = data.recon_id || data.ims_recon_id;
            fetchAndUpdateImsData(imsReconId);
          }
        } catch (err) {
          console.log("Ignoring non-json SSE message:", event.data);
        }
      };

      es.onerror = (e) => {
        const rs = eventSourceRef.current?.readyState;
        console.log("SSE onerror fired, readyState:", rs);
        if (rs === 2) {
          if (eventSourceRef.current) {
            eventSourceRef.current.close();
            eventSourceRef.current = null;
          }
          if (!sseOpenedRef.current) {
            reject(new Error("SSE connection failed permanently"));
          }
        }
      };
    });
  };

  const handleRunReportInTab = async () => {
    const business_entity_id = localStorage.getItem("business_entity_id");
    const org_gstin = localStorage.getItem("gstin") || localStorage.getItem("gst");

    if (!business_entity_id || !org_gstin) {
      setSnackbar({ open: true, message: "Missing business entity or GSTIN information", severity: "error" });
      return;
    }

    try {
      setLoaderForTable(true);
      setSnackbar({ open: true, message: "Opening SSE connection...", severity: "info" });

      const sseToken = generateUUID();

      // STEP 1 — Wait until SSE actually opens
      await initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');
      setSnackbar({ open: true, message: "Reconciliation started. Waiting for result...", severity: "info" });

      const payload = {
        report_type: "ims",
        org_gstin: org_gstin,
        business_entity_id: parseInt(business_entity_id),
        sse_token: sseToken,
        functionality: 'IMS Recon', // ── VERIFY against backend log
      };

      // STEP 2 — Start recon only AFTER SSE is open
      const reconResponse = await axios.post("/unified_auto_reconciliation", payload);
      console.log('Recon API response:', reconResponse.data);

      if (!reconResponse.data || reconResponse.data.status === false) {
        if (eventSourceRef.current) { eventSourceRef.current.close(); eventSourceRef.current = null; }
        setLoaderForTable(false);
        setSnackbar({ open: true, message: reconResponse.data?.message || "Failed to initiate reconciliation", severity: "error" });
        return;
      }

      setSnackbar({ open: true, message: "Reconciliation initiated. Waiting for result...", severity: "info" });
      // Result arrives via SSE → fetchAndUpdateImsData

    } catch (error) {
      if (eventSourceRef.current) { eventSourceRef.current.close(); eventSourceRef.current = null; }
      setLoaderForTable(false);
      setSnackbar({ open: true, message: error?.response?.data?.message || error.message || "Failed to run reconciliation.", severity: "error" });
    }
  };

  const fetchAndUpdateImsData = async (imsReconId) => {
    if (!imsReconId) {
      setLoaderForTable(false);
      setIsInitializing(false);
      setSnackbar({ open: true, message: 'No recon ID received from SSE.', severity: 'error' });
      return;
    }

    try {
      setShowTabs(true);
      setShowLogTables(false);
      setIsInitializing(false);
      localStorage.setItem("ims_recon_id", imsReconId);
      setReconId(imsReconId);
      await getApiList(imsReconId);
      await getSummary(imsReconId, []);
      await getApiImsRepository(imsReconId, 0, pagination.rowsPerPage);
      setSnackbar({ open: true, message: 'IMS Reconciliation completed successfully!', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: 'Error loading reconciliation data.', severity: 'error' });
    } finally {
      setLoaderForTable(false);
    }
  };

  const updateChartData = (results) => {
    if (!results || results.length === 0) {
      return;
    }

    const categoriesSet = new Set();
    const statusesSet = new Set();

    results.forEach((item) => {
      categoriesSet.add(item.GSTR_2B_Recon_Remarks || "");
      statusesSet.add(item.Status || "");
    });

    const categories = Array.from(categoriesSet);
    const statuses = Array.from(statusesSet);

    const chartMetrics = [
      {
        key: "Count_of_Invoice_Number",
        name: "Count of Invoice Number",
        yAxis: 0,
      },
      { key: "Integrated_Tax", name: "Integrated Tax (₹)", yAxis: 1 },
      { key: "Central_Tax", name: "Central Tax (₹)", yAxis: 1 },
      { key: "State_UT_Tax", name: "State/UT Tax (₹)", yAxis: 1 },
      { key: "Cess", name: "Cess (₹)", yAxis: 1 },
    ];

    const series = [];
    chartMetrics.forEach((metric) => {
      statuses.forEach((status) => {
        series.push({
          name: `${status} (${metric.name})`,
          metricName: metric.name,
          data: Array(categories.length).fill(0),
          yAxis: metric.yAxis,
        });
      });
    });

    results.forEach((item) => {
      const remark = item.GSTR_2B_Recon_Remarks || "";
      const status = item.Status || "";
      const categoryIndex = categories.indexOf(remark);
      const statusIndex = statuses.indexOf(status);

      chartMetrics.forEach((metric, metricIndex) => {
        const seriesIndex = metricIndex * statuses.length + statusIndex;
        if (series[seriesIndex]) {
          series[seriesIndex].data[categoryIndex] = item[metric.key] || 0;
        }
      });
    });

    const filteredSeries = series.filter((s) =>
      s.data.some((value) => value !== 0),
    );
    setChartData({ categories, series: filteredSeries });
  };

  const handleDownloadReport = (item) => { };

    const handleStatus = (ims_recon_id, newStatus) => async () => {
        console.log("handleStatus ims_recon_id:", ims_recon_id, "newStatus:", newStatus);
        if (typeof ims_recon_id === 'string' || typeof ims_recon_id === 'number') {
            if (newStatus) {
                // Directly update status if provided (from dropdown)
                try {
                    setLoaderForTable(true);
                    await axios.post(`/update_recon_status/${ims_recon_id}`, {
                        status: newStatus.toLowerCase(),
                    });
                    setSnackbar({
                        open: true,
                        message: `${newStatus} updated successfully`,
                        severity: 'success'
                    });
                    if (reconId) {
                        getApiImsRepository(reconId, pagination.page, pagination.rowsPerPage);
                    }
                } catch (error) {
                    console.error('Error updating status:', error);
                    setSnackbar({
                        open: true,
                        message: error.response?.data?.message || `Failed to update status to ${newStatus}`,
                        severity: 'error'
                    });
                } finally {
                    setLoaderForTable(false);
                }
            } else {
                // Open modal if no status is provided (e.g., from VisibilityIcon)
                setSelectedReconId(ims_recon_id);
                // setModalOpen(true);
            }
        } else {
            setSnackbar({
                open: true,
                message: "Invalid Recon ID",
                severity: 'error'
            });
        }
    };

    const getApiLogReport = () => {
        setLoaderForTable(true);
        axios
            .get(`/ims_reecon_log_summary/${businessEntityId}`)
            .then((response) => {
                console.log('getApiLogReport response:', response.data);
                setRecordForLogTable(response.data.data || []);
                setErrorLogId(response.data.data?.length > 0 ? response.data.data[0].error_log_id : null);
                setLoaderForTable(false);
                const logEntry = response.data.data?.find(entry => entry.ims_recon_id === ims_recon_id);
                if (logEntry && logEntry.tax_period) {
                    console.log('Setting tax_period:', logEntry.tax_period);
                    setTaxPeriod(logEntry.tax_period);
                }
                if (response.data && response.data.Message) {
                    setSnackbar({
                        open: true,
                        message: response.data.Message,
                        severity: 'success'
                    });
                    if (response.data.ims_recon_id || response.data.tax_period) {
                        setReconId(response.data.ims_recon_id);
                        setTaxPeriod(response.data.tax_period)
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching log report:', error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: 'Error fetching IMS log report',
                    severity: 'error'
                });
            });
    };
    const getApiImsRecon = (ims_recon_id) => {
    const business_entity_id = localStorage.getItem("business_entity_id");
    console.log("Fetching IMS Recon Report with reconId:", ims_recon_id);
    setLoaderForTable(true);
    
    axios
        .get(`/ims_inward_recon_report/${ims_recon_id}`)
        .then((res) => {
            console.log("IMS Recon Report Response:", res.data);
            if (res.data.status && Array.isArray(res.data.records)) {
                setRecordForImsReconTable(res.data.records);
            } else {
                setSnackbar({
                    open: true,
                    message: res.data.message || "Invalid API response: Expected records array",
                    severity: 'error'
                });
            }
            setLoaderForTable(false);
        })
        .catch((error) => {
            console.error("Error fetching IMS Recon report:", error);
            setLoaderForTable(false);
            setSnackbar({
                open: true,
                message: error.response?.data?.message || "Error fetching IMS Recon report",
                severity: 'error'
            });
        });
};

    const getApiList = (ims_recon_id) => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        axios
            .get(`/ims_card_data/${ims_recon_id}/${business_entity_id}`)
            .then((response) => {
                console.log('getApiList response:', response.data);
                const metricsData = {
                    accepted: { count: 0, total: 0 },
                    rejected: { count: 0, total: 0 },
                    pending: { count: 0, total: 0 },
                    noAction: { count: 0, total: 0 },
                };

                response.data.forEach((item) => {
                    switch (item.Status) {
                        case 'Accepted':
                            metricsData.accepted.count = item.Count;
                            metricsData.accepted.total = item.Total_Value;
                            break;
                        case 'Rejected':
                            metricsData.rejected.count = item.Count;
                            metricsData.rejected.total = item.Total_Value;
                            break;
                        case 'Pending':
                            metricsData.pending.count = item.Count;
                            metricsData.pending.total = item.Total_Value;
                            break;
                        case 'No Action':
                            metricsData.noAction.count = item.Count;
                            metricsData.noAction.total = item.Total_Value;
                            break;
                        default:
                            break;
                    }
                });

                setMetrics(metricsData);
            })
            .catch((error) => {
                console.error('Error fetching card data:', error);
            });
    };


    const getSummary = (ims_recon_id, periods) => {
        const payload = {
            ims_recon_id: ims_recon_id,
            period: periods || [],
        };
        console.log('Sending payload to /ims_summary_by_period:', payload);
        setLoaderForTable(true);
        axios
            .post(`/ims_summary_by_period`, payload)
            .then((response) => {
                console.log('Full API response:', response.data);
                console.log('Available Months:', response.data.available_months);
                console.log('Table Data:', response.data.results);
                const newAvailableMonths = response.data.available_months || [];
                setAvailableMonths(newAvailableMonths);
                setRecordForExpandTable(response.data.results || []);

                // Process chart data dynamically
                const results = response.data.results || [];
        setRecordForExpandTable(results);

        if (
          newAvailableMonths.length > 0 &&
          (!periods || periods.length === 0)
        ) {
          const firstMonth = newAvailableMonths[0];
          setSelectedMonths([firstMonth]);

          axios
            .post(`/ims_summary_by_period`, {
              ims_recon_id: ims_recon_id,
              period: [firstMonth],
            })
            .then((filteredResponse) => {
              const filteredResults = filteredResponse.data.results || [];
              setRecordForExpandTable(filteredResults);
              updateChartData(filteredResults);
              setLoaderForTable(false);
            })
            .catch((error) => {
              console.error("Error fetching filtered summary:", error);
              setLoaderForTable(false);
            });
        } else {
          updateChartData(results);
                setLoaderForTable(false);
        }
            })
            .catch((error) => {
                console.error('Error fetching summary:', error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || 'Error fetching IMS summary',
                    severity: 'error'
                });
            });
    };

    const onClickRunIms = () => {
        const payload = {
            org_gstin: localStorage.getItem('gst'),
            business_entity_id: localStorage.getItem('business_entity_id'),
        };

        axios
            .post(`/ims_recon_api`, payload)
            .then((response) => {
                console.log('IMS Recon API response:', response.data);
                // Check if the response indicates success
                if (response.data && response.data.status === true) {
                    setSnackbar({
                        open: true,
                        message: response.data.message || 'IMS Reconciliation initiated successfully',
                        severity: 'success',
                    });
                    if (response.data.recon_id) {
                        setReconId(response.data.recon_id);
                    }
                    getApiLogReport();
                } else {
                    // Handle API response with status: false
                    console.warn('API returned failure:', response.data);
                    setSnackbar({
                        open: true,
                        message: response.data.message || 'Failed to initiate IMS Reconciliation',
                        severity: 'error',
                    });
                }
            })
            .catch((error) => {
                console.error('Error initiating IMS Recon:', error);
                // Log the full error object for debugging
                console.error('Full error object:', error);
                // Extract error message with fallback
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    'An unexpected error occurred';
                setSnackbar({
                    open: true,
                    message: errorMessage,
                    severity: 'error',
                });
            });
    };

    const onClickBack = () => {
        setShowTabs(false);
        setShowLogTables(true);
        setReconId(null);
        setSelectedMonths([]);
        setRecordForExpandTable([]);
        setPagination({ page: 0, rowsPerPage: 10, total_count: 0, total_pages: 1 }); // Fully reset pagination
    history.push("/reconCards");
    };


    // const navigareToExcelPairing = () => {
    //     setReconId(ims_recon_id);
    //     history.push({
    //         pathname: '/IMSReconciliation_manualPairing',
    //         state: { reconid: ims_recon_id },
    //     });
    // }

    const navigateToExcelPairing = () => {
    const recon_id = localStorage.getItem("ims_recon_id");
    console.log("Recon ID from localStorage:", recon_id);
        history.push({
      pathname: "/IMSReconciliation_manualPairing",
            state: {
        reconid: recon_id,
        returnTab: "imsReport",
            },
        });
    };


    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

  const onClickExportDashboard = () => {
    if (!reconId) {
      setSnackbar({
        open: true,
        message: "No Recon ID available for export",
        severity: "error",
      });
      return;
    }

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `IMS_Dashboard_Report.xlsx`;
    const payload = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      ims_recon_id: reconId,
      extension: "xlsx",
    };

    setSnackbar({
      open: true,
      message: "Exporting dashboard report...",
      severity: "info",
    });

    axios
      .post(`/ims_excel_api`, payload)
      .then((res) => {
        if (res.data.status === "pass") {
          downloadBase64File(contentType, res.data.file, filename);
          setSnackbar({
            open: true,
            message: "Dashboard report exported successfully",
            severity: "success",
          });
        } else {
          setSnackbar({
            open: true,
            message: res.data.message || "Unable to download!",
            severity: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error exporting dashboard report:", error);
        setSnackbar({
          open: true,
          message:
            error.response?.data?.message ||
            "Server Error, Try After Some Time",
          severity: "error",
        });
      });
  };

    const onClickExport = (ims_recon_id) => {
        console.log(ims_recon_id);
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `IMS_Report.xlsx`;
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            ims_recon_id: ims_recon_id
        };

        axios
            .post(`/ims_excel_api`, {
                ...payload, // Spread payload to include business_entity_id
                extension: "xlsx",
            })
            .then((res) => {
                if (res.data.status === "pass") {
                    downloadBase64File(contentType, res.data.file, filename);
                } else {
                    setSnackbar({
                        open: true,
                        message: "Unable to download!",
                        severity: 'error',
                    });
                }
            })
            .catch((error) => {
                setSnackbar({
                    open: true,
                    message: "Server Error, Try After Some Time",
                    severity: 'error',
                });
            });
    };
    const onClickExportImsRecon = () => {
        if (!reconId) {
            setSnackbar({
                open: true,
                message: "No Recon ID available for export",
                severity: 'error',
            });
            return;
        }

        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `IMS_Recon_Report.xlsx`;
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            ims_recon_id: reconId
        };

        setSnackbar({
            open: true,
            message: "Exporting report...",
            severity: 'info',
        });

        axios
            .post(`/ims_recon_report`, {
                ...payload,
                extension: "xlsx",
            })
            .then((res) => {
                if (res.data.status === "pass") {
                    downloadBase64File(contentType, res.data.file, filename);
                    setSnackbar({
                        open: true,
                        message: "Report exported successfully",
                        severity: 'success',
                    });
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Unable to download!",
                        severity: 'error',
                    });
                }
            })
            .catch((error) => {
                console.error('Error exporting IMS Recon report:', error);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Server Error, Try After Some Time",
                    severity: 'error',
                });
            });
    };


    const handleDownloadExcel = (file_id) => {
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `GSTR-1_Filing.xlsx`;

        axios
            .post(`/download_gstr_upload_file`, {
                file_id: file_id,
                extension: "xlsx",
            })
            .then((res) => {
                if (res.data.status === "pass") {
                    downloadBase64File(contentType, res.data.file, filename);
                } else {
                    setSnackbar({
                        open: true,
                        message: "Unable to download!",
                        severity: 'error'
                    });
                }
            })
            .catch((error) => {
                setSnackbar({
                    open: true,
                    message: "Server Error, Try After Some Time",
                    severity: 'error'
                });
            });
    };

  const handleCheckPushStatus = async () => {
    const business_entity_id = localStorage.getItem("business_entity_id");
    const ims_recon_id = localStorage.getItem("ims_recon_id");

    setPushStatusLoading(true);
    try {
      const res = await axios.get(
        `/check_ims_status/${business_entity_id}/${ims_recon_id}`
      );
      const data = res.data;

      // "No push yet" case — don't overwrite existing status
      if (data.status === "error") {
        setPushStatus(prev => prev ?? null);
        return;
      }

      setPushStatus({
        status: data.status,
        date_time: data.pushed_at
          ? new Date(data.pushed_at).toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          : "",
      });
    } catch (error) {
      // Network error — keep previous status intact
      setPushStatus(prev => prev ?? null);
    } finally {
      setPushStatusLoading(false);
    }
    };

    const getApiImsRepository = (ims_recon_id, tax_period) => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        console.log(tax_period);

        setLoaderForTable(true);
        axios
            .get(`/ims_report_summary/${ims_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("IMS Report Response:", res.data);
                if (res.data.status && Array.isArray(res.data.records)) {
                    setRecordForTable(res.data.records);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                    // setPagination({
                    //     page: res.data.pagination.page - 1, // Convert to 0-based
                    //     rowsPerPage: res.data.pagination.per_page,
                    //     total_count: res.data.pagination.total_count,
                    //     total_pages: res.data.pagination.total_pages,
                    // });
                } else {
                    setSnackbar({
                        open: true,
                        message: "Invalid API response: Expected records array",
                        severity: 'error'
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS report summary:", error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS report summary",
                    severity: 'error'
                });
            });
    };

    const getApiImsAccepted = (ims_recon_id) => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        console.log("Fetching IMS Accepted Report with reconId:", ims_recon_id);
        setLoaderForTable(true);

        axios
            .get(`/ims_report_accepted_summary/${ims_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("Full IMS Accepted Report Response:", res.data);

                // Check if response has status and records is an array
                if (res.data.status && Array.isArray(res.data.records)) {
                    // Set records for the table
                    setRecordForAcceptedTable(res.data.records);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                } else {
                    console.warn("Invalid response structure:", res.data);
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Invalid API response: Expected records array",
                        severity: 'error',
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS accepted summary:", {
                    message: error.message,
                    response: error.response?.data,
                    status: error.response?.status,
                });
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS accepted summary",
                    severity: 'error',
                });
            });
    };

    const getApiImsRejected = (ims_recon_id) => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        console.log("Fetching IMS Rejected Report with reconId:", ims_recon_id);
        setLoaderForTable(true);
        axios
            .get(`/ims_report_rejected_summary/${ims_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("IMS Rejected Report Response:", res.data);
                if (res.data.status && Array.isArray(res.data.records)) {
                    setRecordForRejectedTable(res.data.records);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Invalid API response: Expected records array",
                        severity: 'error'
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS rejected summary:", error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS rejected summary",
                    severity: 'error'
                });
            });
    };

    const getApiImsPending = (ims_recon_id) => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        console.log("Fetching IMS Pending Report with reconId:", ims_recon_id);
        setLoaderForTable(true);
        axios
            .get(`/ims_report_pending_summary/${ims_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("IMS Pending Report Response:", res.data);
                if (res.data.status && Array.isArray(res.data.records)) {
                    setRecordForPendingTable(res.data.records);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Invalid API response: Expected records array",
                        severity: 'error'
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS pending summary:", error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS pending summary",
                    severity: 'error'
                });
            });
    };

    const getApiImsNoAction = (ims_recon_id) => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        console.log("Fetching IMS No Action Report with reconId:", ims_recon_id);
        setLoaderForTable(true);
        axios
            .get(`/ims_report_no_action_summary/${ims_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("IMS No Action Report Response:", res.data);
                if (res.data.status && Array.isArray(res.data.records)) {
                    setRecordForNoActionTable(res.data.records);
                    //  setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Invalid API response: Expected records array",
                        severity: 'error'
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS no action summary:", error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS no action summary",
                    severity: 'error'
                });
            });
    };

    const closeEstablisConnectionDrawerHandler = () => {
        setOpenEstablisConnectionDrawer(false);
    }



    const fetchChartData = () => {
        setTimeout(() => {
            const mockChartData = {
                exactMatch: {
                    invoiceCount: 606,
                    integratedTax: 142,
                    centralTax: 606,
                    stateTax: 482,
                    cess: 89,
                },
                mismatch: {
                    invoiceCount: 198,
                    integratedTax: 42,
                    centralTax: 227,
                    stateTax: 164,
                    cess: 56,
                },
                missingInBooks: {
                    invoiceCount: 55,
                    integratedTax: 0,
                    centralTax: 0,
                    stateTax: 0,
                    cess: 0,
                },
                pending: {
                    invoiceCount: 1840,
                    integratedTax: 479,
                    centralTax: 3101955,
                    stateTax: 3019655,
                    cess: 417,
                },
            };
            setChartData(mockChartData);
        }, 2000);
    };

  // useEffect(() => {
  //     getApiLogReport();
  // }, []);

  // Add this to your state declarations at the top of the component
  // const pollingIntervalRef = useRef(null);
  const eventSourceRef = useRef(null);
  const sseOpenedRef = useRef(false);

    useEffect(() => {
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
    };
    }, []);

    useEffect(() => {
        console.log("Active Tab:", activeTab, "Recon ID:", reconId);
        // console.log("Active Tab:", activeTab, "Recon ID:", taxPeriod);
        if (reconId) {
            if (activeTab === "imsReport") {
                getApiImsRepository(reconId, pagination.page, pagination.rowsPerPage);
        handleCheckPushStatus()
      } else if (activeTab === "imsRecon") {
            getApiImsRecon(reconId);
            } else if (activeTab === "accepted") {
                getApiImsAccepted(reconId, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "rejected") {
                getApiImsRejected(reconId, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "pending") {
                getApiImsPending(reconId, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "noAction") {
                getApiImsNoAction(reconId, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "dashboard") {
                fetchChartData();
                getApiList(reconId);
                // Call getSummary with the current selectedMonths
                getSummary(reconId, selectedMonths);
            }
        }
    }, [activeTab, reconId, pagination.page, pagination.rowsPerPage, selectedMonths]);
//      useEffect(() => {
//     if (activeTab === "imsReport" && reconId) {
//       const business_entity_id = localStorage.getItem("business_entity_id");

//       // Fetch log report to get error_log_id
//       axios
//         .get(`/ims_reecon_log_summary/${business_entity_id}`)
//         .then((response) => {
//           const logData = response.data.data || [];

//           // Find the log entry matching current reconId
//           const currentLog = logData.find(
//             (entry) => entry.ims_recon_id === reconId
//           );

//           // Set errorLogId if found
//           if (currentLog && currentLog.error_log_id !== null && currentLog.error_log_id !== undefined) {
//             setErrorLogId(currentLog.error_log_id);
//           } else {
//             setErrorLogId(null);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching log report for error_log_id:", error);
//           setErrorLogId(null);
//         });
//     }
//   }, [activeTab, reconId]);
    const cards = [
        {
            title: 'Accepted',
            value: metrics.accepted.count,
            icon: <CheckIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[0],
        },
        {
            title: 'Rejected',
            value: metrics.rejected.count,
            icon: <ClearIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[1],
        },
        {
            title: 'Pending',
            value: metrics.pending.count,
            icon: <HourglassBottomIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[2],
        },
        {
            title: 'No Action',
            value: metrics.noAction.count,
            icon: <WarningIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[3],
        },
    ];


    const cardsTotal = [
        {
            title: 'Accepted',
            value: `₹${formatNumber(metrics.accepted.total)}`,
            icon: <CheckIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[0],
        },
        {
            title: 'Rejected',
            value: `₹${formatNumber(metrics.rejected.total)}`,
            icon: <ClearIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[1],
        },
        {
            title: 'Pending',
            value: `₹${formatNumber(metrics.pending.total)}`,
            icon: <HourglassBottomIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[2],
        },
        {
            title: 'No Action',
            value: `₹${formatNumber(metrics.noAction.total)}`,
            icon: <WarningIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[3],
        },
    ];

    return (
    <div>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

      {/* ✅ NEW: Show loading spinner during initialization */}
      {isInitializing ? (
        <BoxWrapper>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "400px",
              gap: "20px",
            }}
          >
            <CircularProgress size={60} />
            <Typography variant="h6" color="textSecondary">
              Loading IMS Reconciliation Data...
            </Typography>
          </div>
        </BoxWrapper>
      ) : (
        <>
          {/* ✅ MODIFIED: Only show when NOT initializing */}
          {showLogTable && !reconId && (
            <BoxWrapper>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "400px",
                  padding: "40px",
                  textAlign: "center",
                }}
              >
                <WarningIcon
                  style={{ fontSize: 80, color: "#FFA726", marginBottom: 20 }}
                />
                <Typography
                  variant="h5"
                  gutterBottom
                  style={{ fontWeight: 600, color: "#424242" }}
                >
                  No IMS Reconciliation Data Available
                </Typography>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  style={{ marginBottom: 30 }}
                >
                  No reconciliation records found for this business entity.
                  Please run IMS reconciliation to generate data.
                </Typography>
              </div>
            </BoxWrapper>
          )}

            {showTabs && (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
                        <button
                            className="button-outlined-primary"
                            style={{ marginLeft: "0px", width: "10%" }}
                            onClick={onClickBack}
                        >
                            BACK
                        </button>
                {/* NEW RUN REPORT BUTTON */}
                                <button
                  className="button-outlined-primary"
                  style={{
                    width: "auto",
                    height: "36px",
                    padding: "0 16px",
                    whiteSpace: "nowrap",
                    fontSize: "14px",
                  }}
                  onClick={handleRunReportInTab}
                >
                  Run IMS Report
                                </button>

                        <Dialog
                            open={openEstablisConnectionDrawer}
                            onClose={closeEstablisConnectionDrawerHandler}
                            fullWidth
                            maxWidth="xs"
                            PaperProps={{
                                sx: {
                                    borderRadius: 2,
                                    boxShadow: 24,
                                    p: 2,
                      bgcolor: "background.default",
                      zIndex: 1300,
                                },
                            }}
                        >
                  <DialogTitle style={{ fontWeight: "600" }}>
                    Establish Connection
                  </DialogTitle>
                            <DialogContent>
                                <ValidatorForm
                                    ref={form}
                                    onSubmit={getOtpForAuthHandler}
                                    onError={(errors) => console.log(errors)}
                                >
                                    <Inputfield
                                        textLabel="User Name"
                                        inputType="text"
                                        name="user_name"
                                        value={username}
                        textOnchangeFunction={(e) =>
                          setUserName(e.target.value)
                        }
                                        requiredField="*"
                                        validator={["required"]}
                                        errorMsg={["This field is required"]}
                                    />
                                    <div className="mt-20">
                                        <button className="button-primary" type="submit">
                                            Submit
                                        </button>
                                        <button
                                            className="button-outlined-secondary"
                                            type="button"
                                            onClick={closeEstablisConnectionDrawerHandler}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </ValidatorForm>
                            </DialogContent>
                        </Dialog>


                        <Modal open={openOTPModal}>
                            <Box sx={style}>
                                <ValidatorForm
                                    ref={form}
                                    onSubmit={vyanaAuthHandler}
                      onError={(errors) =>
                        console.log("ValidatorForm errors:", errors)
                      }
                                >
                                    <Inputfield
                                        textLabel="OTP"
                                        inputType="text"
                                        name="OTP"
                                        value={auth_otp}
                                        textOnchangeFunction={(e) => setAuthOTP(e.target.value)}
                                        requiredField="*"
                                        validator={["required"]}
                                        errorMsg={["This field is required"]}
                                    />
                                    <div className="mt-20">
                                        <button className="button-primary" type="submit">
                                            Submit
                                        </button>
                                        <button
                                            className="button-outlined-secondary"
                                            type="button"
                                            onClick={closeOptModalHandler}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </ValidatorForm>
                            </Box>
                        </Modal>

                        {/* <button
                            className="button-outlined-primary"
                            style={{ marginLeft: "0px", width: "10%" }}
                            onClick={onClickExport}
                        >
                            EXPORT
                        </button> */}
                        {activeTab === 'imsReport' && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', marginTop: '16px' }}>
                                {successMessage === 'Connection established.' ? (
                                    <button
                                        className="button-outlined-primary"
                                        color="success"
                                        sx={{ fontSize: '13px', padding: '4px 8px', mb: '4px', backgroundColor:'#191970' }}
                                        aria-label="Connection established"
                                        style={{backgroundColor:'#03406d', color:'white'}}
                                    >
                                        Connection Established
                                    </button>
                                    //                     <button
                                    //     className="button-outlined-primary"
                                    //     style={{ marginLeft: "0px", width: "15%", marginTop: "1px" }}
                                    //     onClick={this.handleBack}
                                    //   >
                                    //     BACK
                                    //   </button>
                                ) : (
                                    <button
                                        className="button-outlined-primary"
                                        onClick={() => setOpenEstablisConnectionDrawer(true)}

                                        sx={{ fontSize: '13px', padding: '4px 8px', mb: '4px' }}
                                        aria-label="Establish connection"
                                    >
                                        {establishConnectionButton === 'button-outlined-secondary'
                                            ? 'Establish Connection'
                                            : 'Connection Established'}
                                    </button>
                                )}
                                <button
                                    endIcon={<AddCircleIcon />}
                                    className="button-outlined-primary"
                                    sx={{ alignSelf: 'flex-end' }}
                                    onClick={navigateToExcelPairing}
                                    aria-label="Manual upload"
                                >
                                    Manual Upload
                                </button>
                            </div>

                            

                            // <Button
                            //     endIcon={<AddCircleIcon />}
                            //     color="success"
                            //     variant="contained"
                            //     style={{ alignSelf: 'flex-end', backgroundColor: '#00c853' }}
                            //     onClick={navigareToExcelPairing}
                            // >
                            //     Manual Upload
                            // </Button>
                        )}
                    </div>
                    
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            backgroundColor: "rgb(243, 245, 248)",
                            padding: "0px 0",
                            borderRadius: "25px",
                            margin: "10px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            border: "1px solid #d1d5db",
                        }}
                    >
                        <button
                            onClick={() => setActiveTab("dashboard")}
                            style={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                                padding: "10px",
                                color: activeTab === "dashboard" ? "#fff" : "#333",
                                fontSize: "14px",
                                background: activeTab === "dashboard" ? "#8295AD" : "transparent",
                                border: "none",
                                borderRadius: "25px",
                                cursor: "pointer",
                                transition: "color 0.3s",
                            }}
                        >
                            <i className="fas fa-tachometer-alt" style={{ fontSize: "20px", marginRight: activeTab === "dashboard" ? "5px" : "0", color: activeTab === "dashboard" ? "#fff" : "#333" }}></i>
                            {activeTab === "dashboard" ? <span>Dashboard</span> : <span style={{ color: "#333" }}>Dashboard</span>}
                            {activeTab === "dashboard" && (
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: "#ff0000",
                                        borderRadius: "50%",
                                    }}
                                ></span>
                            )}
                        </button>
                        <button
    onClick={() => setActiveTab("imsRecon")}
    style={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        padding: "10px",
        color: activeTab === "imsRecon" ? "#fff" : "#333",
        fontSize: "14px",
        background: activeTab === "imsRecon" ? "#8295AD" : "transparent",
        border: "none",
        borderRadius: "25px",
        cursor: "pointer",
        transition: "color 0.3s",
    }}
>
    <i className="fas fa-exchange-alt" style={{ fontSize: "20px", marginRight: activeTab === "imsRecon" ? "5px" : "0", color: activeTab === "imsRecon" ? "#fff" : "#333" }}></i>
    {activeTab === "imsRecon" ? <span>IMS Recon</span> : <span style={{ color: "#333" }}>IMS Recon</span>}
    {activeTab === "imsRecon" && (
        <span
            style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                width: "8px",
                height: "8px",
                backgroundColor: "#ff0000",
                borderRadius: "50%",
            }}
        ></span>
    )}
</button>
                        <button
                            onClick={() => setActiveTab("imsReport")}
                            style={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                                padding: "10px",
                                color: activeTab === "imsReport" ? "#fff" : "#333",
                                fontSize: "14px",
                                background: activeTab === "imsReport" ? "#8295AD" : "transparent",
                                border: "none",
                                borderRadius: "25px",
                                cursor: "pointer",
                                transition: "color 0.3s",
                            }}
                        >
                            <i className="fas fa-file-alt" style={{ fontSize: "20px", marginRight: activeTab === "imsReport" ? "5px" : "0", color: activeTab === "imsReport" ? "#fff" : "#333" }}></i>
                            {activeTab === "imsReport" ? <span>IMS Report</span> : <span style={{ color: "#333" }}>IMS Report</span>}
                            {activeTab === "imsReport" && (
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: "#ff0000",
                                        borderRadius: "50%",
                                    }}
                                ></span>
                            )}
                        </button>
                        <button
                            onClick={() => setActiveTab("accepted")}
                            style={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                                padding: "10px",
                                color: activeTab === "accepted" ? "#fff" : "#333",
                                fontSize: "14px",
                                background: activeTab === "accepted" ? "#8295AD" : "transparent",
                                border: "none",
                                borderRadius: "25px",
                                cursor: "pointer",
                                transition: "color 0.3s",
                            }}
                        >
                            <i className="fas fa-check-circle" style={{ fontSize: "20px", marginRight: activeTab === "accepted" ? "5px" : "0", color: activeTab === "accepted" ? "#fff" : "#333" }}></i>
                            {activeTab === "accepted" ? <span>Accepted</span> : <span style={{ color: "#333" }}>Accepted</span>}
                            {activeTab === "accepted" && (
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: "#ff0000",
                                        borderRadius: "50%",
                                    }}
                                ></span>
                            )}
                        </button>
                        <button
                            onClick={() => setActiveTab("rejected")}
                            style={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                                padding: "10px",
                                color: activeTab === "rejected" ? "#fff" : "#333",
                                fontSize: "14px",
                                background: activeTab === "rejected" ? "#8295AD" : "transparent",
                                border: "none",
                                borderRadius: "25px",
                                cursor: "pointer",
                                transition: "color 0.3s",
                            }}
                        >
                            <i className="fas fa-times-circle" style={{ fontSize: "20px", marginRight: activeTab === "rejected" ? "5px" : "0", color: activeTab === "rejected" ? "#fff" : "#333" }}></i>
                            {activeTab === "rejected" ? <span>Rejected</span> : <span style={{ color: "#333" }}>Rejected</span>}
                            {activeTab === "rejected" && (
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: "#ff0000",
                                        borderRadius: "50%",
                                    }}
                                ></span>
                            )}
                        </button>
                        <button
                            onClick={() => setActiveTab("pending")}
                            style={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                                padding: "10px",
                                color: activeTab === "pending" ? "#fff" : "#333",
                                fontSize: "14px",
                                background: activeTab === "pending" ? "#8295AD" : "transparent",
                                border: "none",
                                borderRadius: "25px",
                                cursor: "pointer",
                                transition: "color 0.3s",
                            }}
                        >
                            <i className="fas fa-hourglass-half" style={{ fontSize: "20px", marginRight: activeTab === "pending" ? "5px" : "0", color: activeTab === "pending" ? "#fff" : "#333" }}></i>
                            {activeTab === "pending" ? <span>Pending</span> : <span style={{ color: "#333" }}>Pending</span>}
                            {activeTab === "pending" && (
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: "#ff0000",
                                        borderRadius: "50%",
                                    }}
                                ></span>
                            )}
                        </button>
                        <button
                            onClick={() => setActiveTab("noAction")}
                            style={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                                padding: "10px",
                                color: activeTab === "noAction" ? "#fff" : "#333",
                                fontSize: "14px",
                                background: activeTab === "noAction" ? "#8295AD" : "transparent",
                                border: "none",
                                borderRadius: "25px",
                                cursor: "pointer",
                                transition: "color 0.3s",
                            }}
                        >
                            <i className="fas fa-exclamation-circle" style={{ fontSize: "20px", marginRight: activeTab === "noAction" ? "5px" : "0", color: activeTab === "noAction" ? "#fff" : "#333" }}></i>
                            {activeTab === "noAction" ? <span>No Action</span> : <span style={{ color: "#333" }}>No Action</span>}
                            {activeTab === "noAction" && (
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: "#ff0000",
                                        borderRadius: "50%",
                                    }}
                                ></span>
                            )}
                        </button>
                    </div>

                    <div style={{ flex: 1, padding: "20px" }}>
                        {activeTab === "dashboard" && (
                            <>
                                <Grid container spacing={6} justifyContent="center" sx={{ padding: 2 }}>
                                    {cards.map((card, index) => (
                                        <Grid item xs={12} sm={6} md={3} key={index}>
                                            <DashboardCard
                                                title={card.title}
                                                value={card.value}
                                                icon={card.icon}
                                                iconColor={card.iconColor}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                                <Grid container spacing={6} justifyContent="center" sx={{ padding: 2 }}>
                                    {cardsTotal.map((card, index) => (
                                        <Grid item xs={12} sm={6} md={3} key={index}>
                                            <DashboardCard
                                                title={card.title}
                                                value={card.value}
                                                icon={card.icon}
                                                iconColor={card.iconColor}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                                <ExpandableTable
                                    availableMonths={availableMonths}
                                    selectedMonths={selectedMonths}
                                    setSelectedMonths={setSelectedMonths}
                                    reconId={reconId}
                                    getSummary={getSummary}
                                    recordForExpandTable={recordForExpandTable}
                                    loaderForTable={loaderForTable}
                      onClickExport={onClickExportDashboard}
                                />
                                {chartData && (
                      <Box sx={{ mt: 3 }}>
                                        <IMSChart chartData={chartData} />
                                    </Box>
                                )}
                            </>
                        )}
                 {activeTab === "imsRecon" && (
    <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
        <IMSRecon
            recordForImsReconTable={recordForImsReconTable}
            loaderForTable={loaderForTable}
            getApiImsRecon={() => reconId && getApiImsRecon(reconId)}
            ims_recon_id={reconId}
            activeTab={activeTab}
            onClickExportImsRecon={onClickExportImsRecon}  // ADD THIS LINE
        />
    </div>
)}
                        {activeTab === "imsReport" && (
                            <IMSReport
                                recordForTable={recordForTable}
                                loaderForTable={loaderForTable}
                    getApiImsReport={() =>
                      reconId &&
                      getApiImsRepository(reconId, 0, pagination.rowsPerPage)
                    }
                    onCheckPushStatus={handleCheckPushStatus}
                                pagination={pagination}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                handleStatus={handleStatus}
                                activeTab={activeTab}
                                errorLogId={errorLogId}
                    setErrorLogId={setErrorLogId}
                                ims_recon_id={reconId}
                                tax_period={taxPeriod}
                    onRunReport={handleRunReportInTab}
                    pushStatus={pushStatus}
                    setPushStatus={setPushStatus}
                    pushStatusLoading={pushStatusLoading}
                            />

                        )}
                        {activeTab === "accepted" && (
                            <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                                <IMSAccepted
                                    recordForAcceptedTable={recordForAcceptedTable}
                                    loaderForTable={loaderForTable}
                                    // getApiImsAccepted={getApiImsAccepted}
                                    getApiImsAccepted={() => reconId && getApiImsAccepted(reconId, 0, pagination.rowsPerPage)}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    handleRowsPerPageChange={handleRowsPerPageChange}
                                    activeTab={activeTab}

                                />
                            </div>
                        )}
                        {activeTab === "rejected" && (
                            <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                                <IMSRejected
                                    recordForRejectedTable={recordForRejectedTable}
                                    loaderForTable={loaderForTable}
                                    handleStatus={handleStatus}
                                    getApiImsRejected={() => reconId && getApiImsRejected(reconId, 0, pagination.rowsPerPage)}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    handleRowsPerPageChange={handleRowsPerPageChange}
                                    activeTab={activeTab}
                                />
                            </div>
                        )}
                        {activeTab === "pending" && (
                            <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                                <IMSPending
                                    recordForPendingTable={recordForPendingTable}
                                    loaderForTable={loaderForTable}
                                    handleStatus={handleStatus}
                                    reconId={reconId}
                                    getApiImsPending={() => reconId && getApiImsPending(reconId, 0, pagination.rowsPerPage)}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    handleRowsPerPageChange={handleRowsPerPageChange}
                                    activeTab={activeTab}
                                />
                            </div>
                        )}
                        {activeTab === "noAction" && (
                            <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                                <IMSNoAction
                                    recordForNoActionTable={recordForNoActionTable}
                                    loaderForTable={loaderForTable}
                                    handleStatus={handleStatus}
                                    reconId={reconId}
                                    getApiImsNoAction={() => reconId && getApiImsNoAction(reconId, 0, pagination.rowsPerPage)}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    handleRowsPerPageChange={handleRowsPerPageChange}
                                    activeTab={activeTab}
                                />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
      )}
        </div>
    );
}